//import Moment from 'moment';
// import Moment from 'moment/min/moment-with-locales';
import "moment/min/locales";
import Moment from "moment";
// import React from 'react';
import * as formulajs from "@formulajs/formulajs"; // import entire package
import authHeader from "./services/auth-header";
import { API } from "./backend";

const DatePicker = (date) => {
  return Moment(date).format("YYYY-MM-DD");
};

const DateNormal = (date1) => {
  let localeFormat = "";
  const customerPermission = localStorage.getItem("customer");
  if (customerPermission !== "Customer") {
    localeFormat = localStorage.getItem("locale");
  } else {
    localeFormat = "en_US";
  }
  localeFormat.replace("_", "-");
  return Moment(date1).locale(localeFormat).format("L");
};

// const DateTimeNormal=(isoString)=> {
//     if (!isoString) return "";
//     const d = new Date(isoString);
//     // Adjust format to your liking:
//     // e.g. "10/12/2025, 11:33:22"
//     return d.toLocaleString();
//   };

const DateTimeNormal = (isoString) => {
  if (!isoString) return "";

  const d = new Date(isoString);

  const date = d.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });

  const time = d.toLocaleTimeString("en-US", {
    hour12: false,
  });

  return `${date} ${time}`;
};

const Dateview = (date2) => {
  return Moment(date2).format("MM/DD/YYYY");
};

const MonthDifference = (startDate, endDate) => {
  return (
    endDate.getMonth() -
    startDate.getMonth() +
    12 * (endDate.getFullYear() - startDate.getFullYear())
  );
};


// const Amount = (amount) => {
//   const customerPermission = localStorage.getItem("customer");
//   let locale = "";

//   if (customerPermission !== "Customer") {
//     locale = localStorage.getItem("locale");
//   } else {
//     locale = "en_US";
//   }

//   // Convert to number
//   let amt = parseFloat(amount);

//   // Truncate to 2 decimals without rounding
//   amt = Math.trunc(amt * 100) / 100;

//   // Format without changing the value
//   return new Intl.NumberFormat(locale.replace("_", "-"), {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   }).format(amt);
// };


const Amount = (amount) => {
  const customerPermission = localStorage.getItem("customer");
  let locale = "";
  if (customerPermission !== "Customer") {
    locale = localStorage.getItem("locale");
  } else {
    locale = "en_US";
  }
  if (amount > 0) {
    let amt = parseFloat(amount);
    return new Intl.NumberFormat(locale.replace("_", "-"), {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amt);
  } else {
    return new Intl.NumberFormat(locale.replace("_", "-"), {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }
};

const TaxRateAmount = (amount) => {
  const customerPermission = localStorage.getItem("customer");
  let locale = "";
  if (customerPermission !== "Customer") {
    locale = localStorage.getItem("locale");
  } else {
    locale = "en_US";
  }
  if (amount > 0) {
    let amt = parseFloat(amount);
    return new Intl.NumberFormat(locale.replace("_", "-"), {
      minimumFractionDigits: 5,
      maximumFractionDigits: 5,
    }).format(amt);
  } else {
    return new Intl.NumberFormat(locale.replace("_", "-"), {
      minimumFractionDigits: 5,
      maximumFractionDigits: 5,
    }).format(amount);
  }
};

const DueDays = (duedate) => {
  const date1 = new Date();
  const date2 = new Date(duedate);
  // One day in milliseconds
  const oneDay = 1000 * 60 * 60 * 24;
  // Calculating the time difference between two dates
  const diffInTime = date2.getTime() - date1.getTime();
  // Calculating the no. of days between two dates
  const diffInDays = Math.round(diffInTime / oneDay);
  if (diffInDays > 0) {
    return "0 days";
  } else {
    return Math.abs(diffInDays) + " days";
  }
};

const isLastDayOfMonthh = (date) => {
  const nextDay = new Date(date);
  nextDay.setDate(nextDay.getDate() + 1);
  return nextDay.getDate() === 1;
};

const getLastDayOfMonth = (year, month) => {
  return new Date(year, month + 1, 0);
};
const calculatePaymentDates = (
  contractDate,
  paymentRule,
  payment_count,
  paymentFrequency,
  noTerms,
  items,
  feedefination,
  contract_type
) => {
  const frequencyMapping = {
    Monthly: 1,
    Quarterly: 3,
    "Semi-annual": 6,
    Annual: 12,
  };

  const calculatedPaymentDates = [];
  let currentDate = new Date(contractDate);
  let paymentStartDate = null;
  let lastPaymentType = {};
  let startDate = null;
  let endDate = null;

  items.forEach((item, index) => {
    const {
      amount,
      no_of_payments,
      payment_type,
      start_date,
      end_date,
      periods,
    } = item;
    const filterfeenature = feedefination.filter(
      (value) => value.fee_name === payment_type
    );
    const isLastDayOfMonth =
      currentDate.getDate() ===
      new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        0
      ).getDate();

    currentDate = new Date(start_date);
    const contractDateObj = new Date(contractDate);

    if (amount >= 0 && no_of_payments > 0) {
      if (paymentRule === "Advance") {
        if (typeof lastPaymentType[payment_type] === "undefined") {
          paymentStartDate = new Date(contractDate);
        } else {
          paymentStartDate = lastPaymentType[payment_type];
        }
      } else if (paymentRule === "Arrears") {
        const cycleMonths = frequencyMapping[paymentFrequency];
        if (typeof lastPaymentType[payment_type] === "undefined") {
          paymentStartDate = new Date(
            contractDateObj.getFullYear(),
            contractDateObj.getMonth() + cycleMonths,
            contractDateObj.getDate()
          );
        } else {
          paymentStartDate = lastPaymentType[payment_type];
        }
      }

      let calculatedNoTerms;
      switch (paymentFrequency) {
        case "Monthly":
          calculatedNoTerms = parseInt(noTerms) / 1;
          break;
        case "Quarterly":
          calculatedNoTerms = parseInt(noTerms) / 3;
          break;
        case "Annual":
          calculatedNoTerms = parseInt(noTerms) / 12;
          break;
        case "Semi-annual":
          calculatedNoTerms = parseInt(noTerms) / 6;
          break;
        default:
          throw new Error("Invalid payment frequency");
      }

      for (let i = 0; i < no_of_payments; i++) {
        // let endDate = new Date(
        //   currentDate.getFullYear(),
        //   currentDate.getMonth() + frequencyMapping[paymentFrequency],
        //   currentDate.getDate()
        // );
        if (isLastDayOfMonth === true) {
          startDate = new Date(
            paymentStartDate.getFullYear(),
            paymentStartDate.getMonth(),
            paymentStartDate.getDate() // Add one day to the start date
          );
        } else {
          if (paymentRule === 'Advance') {

            startDate = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate() // Add one day to the start date
            );
          }
          else {

            startDate = new Date(
              currentDate.getFullYear(),
              // currentDate.getMonth() - frequencyMapping[paymentFrequency],
              currentDate.getMonth(),
              currentDate.getDate() // Add one day to the start date
            );
          }
          // startDate = new Date(
          //   currentDate.getFullYear(),
          //   currentDate.getMonth(),
          //   currentDate.getDate() // Add one day to the start date
          // );
        }
        //  startDate = new Date(
        //   currentDate.getFullYear(),
        //   currentDate.getMonth(),
        //   currentDate.getDate()
        // );
        if (isLastDayOfMonth === true) {
          let lastDayCurrentMonth = getLastDayOfMonth(
            startDate.getFullYear(),
            startDate.getMonth() + frequencyMapping[paymentFrequency]
          );
          endDate = new Date(
            startDate.getFullYear(),
            startDate.getMonth() + frequencyMapping[paymentFrequency],
            lastDayCurrentMonth.getDate() - 1
          );
        } else {
          endDate = new Date(
            // currentDate.getFullYear(),
            startDate.getFullYear(),
            startDate.getMonth() + frequencyMapping[paymentFrequency],
            currentDate.getDate() - 1
          );
        }
        if (filterfeenature.length !== 0) {
          if (filterfeenature[0].fee_nature === "One Time") {
            startDate = new Date(start_date);
            endDate = new Date(end_date);
          }
        }
        // if (payment_type === "One-Time Fee") {
        //   startDate = new Date(start_date);
        //   endDate = new Date(end_date);
        // }

        const paymentEntry = {
          // paymentdate: paymentStartDate.toLocaleDateString("en-US"),
          // paymentdate: DatePicker(paymentStartDate),
          // paymentdate: paymentRule ==="Arrears"?Helper.DatePicker(endDate):Helper.DatePicker(paymentStartDate),
          // paymentdate: paymentRule ==="Arrears"?Helper.DatePicker(startDate):Helper.DatePicker(paymentStartDate),
          paymentdate: paymentRule === "Arrears" ? Helper.DatePicker(paymentStartDate) : Helper.DatePicker(paymentStartDate),
          // startdate: startDate.toLocaleDateString("en-US"),
          startdate: DatePicker(startDate),
          // enddate: endDate.toISOString().split("T")[0],
          // enddate: endDate.toLocaleDateString("en-US"),
          enddate: DatePicker(endDate),
          periodicamount: amount,
          txn_number: `TRAN${index + 1}`,
          payment_type: payment_type,
        };

        calculatedPaymentDates.push(paymentEntry);

        currentDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() + frequencyMapping[paymentFrequency],
          currentDate.getDate()
        );
        if (isLastDayOfMonth == true) {
          paymentStartDate = new Date(
            endDate.getFullYear(),
            endDate.getMonth() + 1,
            0
          );
        } else {
          paymentStartDate = new Date(
            paymentStartDate.getFullYear(),
            paymentStartDate.getMonth() + frequencyMapping[paymentFrequency],
            paymentStartDate.getDate()
          );
        }
      }

      lastPaymentType[payment_type] = paymentStartDate;
    }
  });
  return calculatedPaymentDates;
};

const isFirstDayOfMonth = (date) => {
  return date.getDate() === 1;
};
const calculatedLoanPaymentDates = (
  contractDate,
  paymentRule,
  payment_count,
  paymentFrequency,
  noTerms,
  items,
  feedefination,
  contract_type
) => {
  if (items) {

    const frequencyMapping = {
      Monthly: 1,
      Quarterly: 3,
      "Semi-annual": 6,
      Annual: 12,
    };
    const contractDateObj = new Date(contractDate);

    const calculatedPaymentDatess = [];
    let currentDate = new Date(contractDate);
    let paymentStartDate = null;
    let lastPaymentType = {};
    let startDate = null;
    let endDate = null;
    // let value = "";
    const isLeapYear = (year) => {
      return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
    };

    const getLastDayOfMonthh = (year, month) => {
      return new Date(year, month + 1, 0).getDate();
    };

    items.forEach((item, index) => {
      const { amount, periods, payment_type, start_date, end_date } = item;
      const filterfeenature = feedefination.filter(
        (value) => value.fee_name === payment_type
      );
      // currentDate = new Date(start_date);
      // const isLastDayOfMonth =
      //   currentDate.getDate() ===
      //   new Date(
      //     currentDate.getFullYear(),
      //     currentDate.getMonth() + 1,
      //     0
      //   ).getDate();
      currentDate = new Date(start_date);
      const contractDay = contractDateObj.getDate();

      if (amount >= 0 && periods > 0) {
        if (paymentRule === "Advance") {
          if (typeof lastPaymentType[payment_type] === "undefined") {
            paymentStartDate = contractDateObj;
          } else {
            paymentStartDate = lastPaymentType[payment_type];
          }
        } else if (paymentRule === "Arrears") {
          const cycleMonths = frequencyMapping[paymentFrequency];
          if (typeof lastPaymentType[payment_type] === "undefined") {
            paymentStartDate = new Date(
              contractDateObj.getFullYear(),
              contractDateObj.getMonth() + cycleMonths,
              contractDateObj.getDate()
            );
          } else {
            paymentStartDate = lastPaymentType[payment_type];
          }
        }

        let calculatedNoTerms;
        switch (paymentFrequency) {
          case "Monthly":
            calculatedNoTerms = parseInt(noTerms) / 1;
            break;
          case "Quarterly":
            calculatedNoTerms = parseInt(noTerms) / 3;
            break;
          case "Annual":
            calculatedNoTerms = parseInt(noTerms) / 12;
            break;
          case "Semi-annual":
            calculatedNoTerms = parseInt(noTerms) / 6;
            break;
          default:
            throw new Error("Invalid payment frequency");
        }

        for (let i = 0; i < periods; i++) {
          startDate = new Date(currentDate);

          const nextMonth = startDate.getMonth() + frequencyMapping[paymentFrequency];
          const nextYear = startDate.getFullYear() + Math.floor(nextMonth / 12);
          const adjustedNextMonth = nextMonth % 12;

          const nextLastDay = getLastDayOfMonth(nextYear, adjustedNextMonth);
          const nextDay = Math.min(contractDay, nextLastDay);

          // Adjust for end dates and leap years
          if (adjustedNextMonth === 1 && contractDay > 28) {
            if (isLeapYear(nextYear)) {
              endDate = new Date(nextYear, adjustedNextMonth, 30);
            } else {
              endDate = new Date(nextYear, adjustedNextMonth, 29);
            }
          } else {
            endDate = new Date(nextYear, adjustedNextMonth, contractDateObj.getDate());
          }
          // if (isLastDayOfMonth === true) {
          //   let lastDayCurrentMonth = getLastDayOfMonth(
          //     startDate.getFullYear(),
          //     startDate.getMonth() + frequencyMapping[paymentFrequency]
          //   );
          //   endDate = new Date(
          //     startDate.getFullYear(),
          //     startDate.getMonth() + frequencyMapping[paymentFrequency],
          //     lastDayCurrentMonth.getDate() - 1
          //   );
          // } else {
          //   endDate = new Date(
          //     currentDate.getFullYear(),
          //     currentDate.getMonth() + frequencyMapping[paymentFrequency],
          //     currentDate.getDate() - 1
          //   );
          // }
          if (filterfeenature.length !== 0) {
            if (filterfeenature[0].fee_nature === "One Time") {
              startDate = new Date(start_date);
              endDate = new Date(end_date);
            }
          }

          // const paymentEntry = {
          //   paymentdate: paymentRule === "Arrears" ? Helper.DatePicker(endDate) : Helper.DatePicker(paymentStartDate),
          //   startdate: Helper.DatePicker(startDate),
          //   enddate: Helper.DatePicker(endDate),
          //   periodicamount: amount,
          //   txn_number: `TRAN${index + 1}`,
          //   payment_type: payment_type,
          // };
          const paymentEntry = {
            paymentdate: paymentRule === "Arrears" ? Helper.DatePicker(new Date(endDate.getTime() - 24 * 60 * 60 * 1000)) : Helper.DatePicker(new Date(paymentStartDate)),
            startdate: Helper.DatePicker(startDate),
            enddate: Helper.DatePicker(new Date(endDate.getTime() - 24 * 60 * 60 * 1000)),
            periodicamount: amount,
            txn_number: `TRAN${index + 1}`,
            payment_type: payment_type,
          };

          calculatedPaymentDatess.push(paymentEntry);

          // currentDate = new Date(
          //   currentDate.getFullYear(),
          //   currentDate.getMonth() + frequencyMapping[paymentFrequency],
          //   currentDate.getDate()
          // );
          currentDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth() + frequencyMapping[paymentFrequency],
            Math.min(
              currentDate.getDate(),
              getLastDayOfMonthh(currentDate.getFullYear(), currentDate.getMonth() + frequencyMapping[paymentFrequency])
            )
          );
          if (contractDay > getLastDayOfMonth(currentDate.getFullYear(), currentDate.getMonth())) {
            currentDate.setDate(getLastDayOfMonth(currentDate.getFullYear(), currentDate.getMonth()));
          }

          paymentStartDate = new Date(
            paymentStartDate.getFullYear(),
            paymentStartDate.getMonth() + frequencyMapping[paymentFrequency],
            Math.min(
              paymentStartDate.getDate(),
              getLastDayOfMonth(paymentStartDate.getFullYear(), paymentStartDate.getMonth() + frequencyMapping[paymentFrequency])
            )
          );


          // if (isLastDayOfMonth) {
          //   paymentStartDate = new Date(
          //     endDate.getFullYear(),
          //     endDate.getMonth() + frequencyMapping[paymentFrequency],
          //     endDate.getDate() - 1
          //   );
          // } else {
          //   paymentStartDate = new Date(
          //     paymentStartDate.getFullYear(),
          //     paymentStartDate.getMonth() + frequencyMapping[paymentFrequency],
          //     Math.min(
          //       paymentStartDate.getDate(),
          //       getLastDayOfMonthh(paymentStartDate.getFullYear(), paymentStartDate.getMonth() + frequencyMapping[paymentFrequency])
          //     )
          //   );
          // }
        }

        lastPaymentType[payment_type] = paymentStartDate;
      }
    });
    // calculatedPaymentDatess.sort((a, b) => {
    //   const dateA = new Date(a.paymentdate);
    //   const dateB = new Date(b.paymentdate);
    //   return dateA - dateB;
    // });
    return calculatedPaymentDatess
    // setPaymentDates(calculatedPaymentDates);
  }
  // if (items) {

  //   const filterfeenature = "Rent";
  //   const isLastDayOfMonth =
  //     currentDate.getDate() ===
  //     new Date(
  //       currentDate.getFullYear(),
  //       currentDate.getMonth() + 1,
  //       0
  //     ).getDate();

  //   currentDate = new Date(items[0]["start_date"]);
  //   if (items[0].amount && items[0]["periods"] > 0) {
  //     if (paymentRule === "Advance") {
  //       if (typeof lastPaymentType[items[0]["payment_type"]] === "undefined") {
  //         paymentStartDate = new Date(contractDate);
  //       } else {
  //         paymentStartDate = lastPaymentType[items[0]["payment_type"]];
  //       }
  //     } else if (paymentRule === "Arrears") {
  //       const cycleMonths = frequencyMapping[paymentFrequency];
  //       if (typeof lastPaymentType[items[0]["payment_type"]] === "undefined") {
  //         paymentStartDate = new Date(
  //           currentDate.getFullYear(),
  //           currentDate.getMonth() + cycleMonths,
  //           currentDate.getDate()
  //         );
  //       } else {
  //         paymentStartDate = lastPaymentType[items[0]["payment_type"]];
  //       }
  //     }

  //     let calculatedNoTerms;
  //     switch (paymentFrequency) {
  //       case "Monthly":
  //         calculatedNoTerms = parseInt(noTerms) / 1;
  //         break;
  //       case "Quarterly":
  //         calculatedNoTerms = parseInt(noTerms) / 3;
  //         break;
  //       case "Annual":
  //         calculatedNoTerms = parseInt(noTerms) / 12;
  //         break;
  //       case "Semi-annual":
  //         calculatedNoTerms = parseInt(noTerms) / 6;
  //         break;
  //       default:
  //         throw new Error("Invalid payment frequency");
  //     }

  //     for (let i = 0; i < items[0].periods; i++) {
  //       if (isLastDayOfMonth === true) {
  //         startDate = new Date(
  //           paymentStartDate.getFullYear(),
  //           paymentStartDate.getMonth(),
  //           paymentStartDate.getDate() // Add one day to the start date
  //         );
  //       } else {
  //         startDate = new Date(
  //           currentDate.getFullYear(),
  //           currentDate.getMonth(),
  //           currentDate.getDate() // Add one day to the start date
  //         );
  //       }
  //       if (isLastDayOfMonth == true) {
  //         let lastDayCurrentMonth = getLastDayOfMonth(
  //           startDate.getFullYear(),
  //           startDate.getMonth() + frequencyMapping[paymentFrequency]
  //         );
  //         endDate = new Date(
  //           startDate.getFullYear(),
  //           startDate.getMonth() + frequencyMapping[paymentFrequency],
  //           lastDayCurrentMonth.getDate() - 1
  //         );
  //       } else {
  //         endDate = new Date(
  //           currentDate.getFullYear(),
  //           currentDate.getMonth() + frequencyMapping[paymentFrequency],
  //           currentDate.getDate() - 1
  //         );
  //       }
  //       const paymentEntry = {
  //         // paymentdate: DatePicker(paymentStartDate),
  //         paymentdate: paymentRule ==="Arrears"?Helper.DatePicker(endDate):Helper.DatePicker(paymentStartDate),
  //         startdate: DatePicker(startDate),
  //         enddate: DatePicker(endDate),
  //         periodicamount: items[0]["amount"],
  //         txn_number: `TRAN${1}`,
  //         payment_type: items[0]["payment_type"],
  //       };

  //       calculatedPaymentDatess.push(paymentEntry);

  //       currentDate = new Date(
  //         currentDate.getFullYear(),
  //         currentDate.getMonth() + frequencyMapping[paymentFrequency],
  //         currentDate.getDate()
  //       );
  //       if (isLastDayOfMonth == true) {
  //         paymentStartDate = new Date(
  //           endDate.getFullYear(),
  //           endDate.getMonth() + 1,
  //           0
  //         );
  //       } else {
  //         paymentStartDate = new Date(
  //           paymentStartDate.getFullYear(),
  //           paymentStartDate.getMonth() + frequencyMapping[paymentFrequency],
  //           paymentStartDate.getDate()
  //         );
  //       }
  //     }

  //     lastPaymentType[items[0].payment_type] = paymentStartDate;
  //   }
  // }
  // return calculatedPaymentDatess;
};

const generateSchedule = (
  startDate,
  numberOfPayments,
  financedAmount,
  paymentAmount,
  paymentFrequency,
  contractiir,
  residual
) => {
  const schedule = [];
  let beginBV = financedAmount;
  let income = 0;
  let capitalRecovery = 0;
  let endBV = 0;
  let incomeRecognized = 0;
  let paymentrentamount = paymentAmount;
  let sumIncomeRecognized = 0;
  startDate = new Date(startDate);
  let monthlyYield = contractiir / 12;
  let dailyYield = monthlyYield / 30;

  for (let i = 0; i < numberOfPayments; i++) {
    const paymentDate = new Date(startDate);
    if (isFirstDayOfMonth(paymentDate)) {
      const term = i + 1;
      const paymentDate = new Date(startDate);
      paymentDate.setMonth(startDate.getMonth() + i);
      const endDate = new Date(paymentDate);
      endDate.setMonth(paymentDate.getMonth() + 1);
      endDate.setDate(endDate.getDate() - 1); // Subtract one day
      const noOfDays = 30;
      const incomeDate = new Date(endDate);
      if (paymentFrequency === "Quarterly" && i % 3 === 0) {
        income = ((beginBV - paymentAmount) * monthlyYield) / 100;
        capitalRecovery = paymentAmount - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
        paymentrentamount = paymentAmount;
      } else if (paymentFrequency === "Monthly") {
        income = ((beginBV - paymentAmount) * monthlyYield) / 100;
        capitalRecovery = paymentAmount - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
      } else if (paymentFrequency === "Semi-annual" && i % 6 === 0) {
        income = ((beginBV - paymentAmount) * monthlyYield) / 100;
        capitalRecovery = paymentAmount - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
      } else if (paymentFrequency === "Annual" && i % 12 === 0) {
        income = ((beginBV - paymentAmount) * monthlyYield) / 100;
        capitalRecovery = paymentAmount - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
      } else {
        income = ((beginBV - 0) * monthlyYield) / 100;
        capitalRecovery = 0 - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
        paymentrentamount = 0;
      }

      schedule.push({
        term,
        paymentDate: DatePicker(paymentDate),
        paymentAmount: paymentrentamount,
        startDate: DatePicker(paymentDate),
        endDate: DatePicker(endDate),
        noOfDays,
        incomeDate: DatePicker(incomeDate),
        beginBV,
        income,
        capitalRecovery,
        endBV,
        incomeRecognized,
      });

      beginBV = endBV;
    } else {
      paymentDate.setMonth(startDate.getMonth() + i);

      const endDate = new Date(paymentDate);
      endDate.setMonth(paymentDate.getMonth() + 1);
      endDate.setDate(0); // Set to the last day of the current month
      const noOfDays = formulajs.DAYS360(paymentDate, endDate);
      const incomeDate = new Date(endDate);
      if (paymentFrequency === "Quarterly" && i % 3 === 0) {
        income = ((beginBV - paymentAmount) * dailyYield * noOfDays) / 100;
        capitalRecovery = paymentAmount - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;
        paymentrentamount = paymentAmount;
      } else if (paymentFrequency === "Annual" && i % 12 === 0) {
        income = ((beginBV - paymentAmount) * dailyYield * noOfDays) / 100;
        capitalRecovery = paymentAmount - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;
        paymentrentamount = paymentAmount;
      } else if (paymentFrequency === "Semi-annual" && i % 6 === 0) {
        income = ((beginBV - paymentAmount) * dailyYield * noOfDays) / 100;
        capitalRecovery = paymentAmount - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;
        paymentrentamount = paymentAmount;
      } else if (paymentFrequency === "Monthly") {
        income = (((beginBV - paymentAmount) * dailyYield) / 100) * noOfDays;
        capitalRecovery = paymentAmount - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;
        paymentrentamount = paymentAmount;
      } else {
        income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
        capitalRecovery = 0 - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;
      }
      // const income =
      //   (((beginBV - paymentAmount) * dailyYield) / 100) * noOfDays;
      // const capitalRecovery = paymentAmount - income;
      // const endBV = beginBV - capitalRecovery;
      // const incomeRecognized = income;

      schedule.push({
        term: i,
        paymentDate: DatePicker(paymentDate),
        paymentAmount: paymentrentamount,
        startDate: DatePicker(paymentDate),
        endDate: DatePicker(endDate),
        noOfDays,
        incomeDate: DatePicker(incomeDate),
        beginBV,
        income,
        capitalRecovery,
        endBV,
        incomeRecognized,
      });

      beginBV = endBV;

      // Second schedule
      const secondPaymentDate = new Date(endDate);
      secondPaymentDate.setDate(secondPaymentDate.getDate() + 1);

      const secondEndDate = new Date(paymentDate);
      secondEndDate.setMonth(secondEndDate.getMonth() + 1);
      secondEndDate.setDate(secondEndDate.getDate() - 1);

      const secondNoOfDays = 30 - noOfDays;
      const secondIncomeDate = new Date(secondEndDate);
      const secondIncome =
        (((beginBV - 0) * dailyYield) / 100) * secondNoOfDays;
      const secondCapitalRecovery = 0 - secondIncome;
      const secondEndBV = beginBV - secondCapitalRecovery;
      const secondIncomeRecognized = secondIncome;
      paymentrentamount = 0;

      schedule.push({
        term: i,
        paymentDate: DatePicker(secondPaymentDate),
        paymentAmount: paymentrentamount,
        startDate: DatePicker(secondPaymentDate),
        endDate: DatePicker(secondEndDate),
        noOfDays: secondNoOfDays,
        incomeDate: DatePicker(secondIncomeDate),
        beginBV,
        income: secondIncome,
        capitalRecovery: secondCapitalRecovery,
        endBV: secondEndBV,
        incomeRecognized: "",
      });

      beginBV = secondEndBV;
      sumIncomeRecognized = secondIncome;
    }
  }
  // if (residual > 0) {
  //   const ResidualPaymentDate = new Date(schedule[schedule.length - 1].endDate);
  //   ResidualPaymentDate.setDate(ResidualPaymentDate.getDate() + 1);

  //   const ResidualEndDate = new Date(ResidualPaymentDate);
  //   ResidualEndDate.setMonth(ResidualEndDate.getMonth() + 1);
  //   ResidualEndDate.setDate(ResidualEndDate.getDate() - 1);

  //   const ResidualNoOfDays = formulajs.DAYS360(
  //     ResidualPaymentDate,
  //     ResidualEndDate
  //   );
  //   const ResidualIncomeDate = new Date(ResidualEndDate);
  //   const ResidualIncome =
  //     (((beginBV - 0) * dailyYield) / 100) * ResidualNoOfDays;
  //   const ResidualCapitalRecovery = 0 - ResidualIncome;
  //   const ResidualEndBV = beginBV - ResidualCapitalRecovery;
  //   const ResidualIncomeRecognized = ResidualIncome;
  //   const ResidualbeginBV = schedule[schedule.length - 1].endBV;
  //   schedule.push({
  //     term: [1],
  //     paymentDate: DatePicker(ResidualPaymentDate),
  //     paymentAmount: 0,
  //     startDate: DatePicker(ResidualPaymentDate),
  //     endDate: DatePicker(ResidualEndDate),
  //     noOfDays: ResidualNoOfDays,
  //     incomeDate: DatePicker(ResidualIncomeDate),
  //     beginBV: ResidualbeginBV,
  //     income: ResidualIncome,
  //     capitalRecovery: ResidualCapitalRecovery,
  //     endBV: ResidualEndBV,
  //     incomeRecognized: ResidualIncomeRecognized,
  //   });
  // }

  return schedule;
};

//testingggggg------
// const generateArrearsSchedule = (
//   startDate,
//   numberOfPayments,
//   financedAmount,
//   paymentAmount,
//   paymentFrequency,
//   contractiir,
//   residual
// ) => {
//   const schedule = [];
//   let beginBV = financedAmount;
//   let income = 0;
//   let capitalRecovery = 0;
//   let endBV = 0;
//   let incomeRecognized = 0;
//   let paymentrentamount = paymentAmount;
//   let sumIncomeRecognized = 0;
//   startDate = new Date(startDate);
//   let monthlyYield = contractiir / 12;
//   let dailyYield = monthlyYield / 30;
//   let Sumofincome = 0
//   let noOfDays = 0

//   for (let i = 0; i < numberOfPayments; i++) {
//     const paymentDate = new Date(startDate);
//     if (isFirstDayOfMonth(paymentDate)) {
//       const term = i + 1;
//       let paymentDate = new Date(startDate);
//       paymentDate.setMonth(startDate.getMonth() + term);
//       paymentDate.setDate(0);
//       const endDate = new Date(paymentDate);
//       const StartDate = new Date(startDate);
//       StartDate.setMonth(StartDate.getMonth() + i);
//       // paymentDate = new Date(endDate)
//       // paymentDate.setMonth(endDate.getMonth())

//       // alert(startDate)
//       // endDate.setMonth(paymentDate.getMonth() + 1);
//       // endDate.setDate(endDate.getDate() - 1); // Subtract one day
//       const noOfDays = 30;
//       const incomeDate = new Date(endDate);
//       if (paymentFrequency === "Quarterly" && (i + 1) % 3 === 0) {
//         income = ((beginBV - 0) * monthlyYield) / 100;
//         capitalRecovery = paymentAmount - (income * 3 )
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income;
//         paymentrentamount = paymentAmount;
//       } else if (paymentFrequency === "Monthly") {
//         income = ((beginBV - 0) * monthlyYield) / 100;
//         capitalRecovery = paymentAmount - income;
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income;
//       } else if (paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0) {
//         income = ((beginBV - 0) * monthlyYield) / 100;
//         capitalRecovery = paymentAmount - (income * 6 );
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income;
//         paymentrentamount = paymentAmount;
//       } else if (paymentFrequency === "Annual" && (i + 1) % 12 === 0) {
//         income = ((beginBV - 0) * monthlyYield) / 100;
//         capitalRecovery = paymentAmount - (income * 12 );
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income;
//         paymentrentamount = paymentAmount;
//       } else {
//         income = ((beginBV - 0) * monthlyYield) / 100;
//         paymentrentamount = 0;
//         if (paymentrentamount == 0){

//           // capitalRecovery = 0 - income;
//           capitalRecovery = 0 ;
//         }
//         else{
//           capitalRecovery = 0 - income;

//         }
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income;
//       }
//       paymentDate.setDate(endDate.getDate());
//       schedule.push({
//         term,
//         // paymentDate: DatePicker(paymentDate),
//         paymentDate: DatePicker(endDate),
//         paymentAmount: paymentrentamount,
//         startDate: DatePicker(StartDate),
//         endDate: DatePicker(endDate),
//         noOfDays,
//         incomeDate: DatePicker(incomeDate),
//         beginBV,
//         income,
//         capitalRecovery,
//         endBV,
//         incomeRecognized,
//       });

//       beginBV = endBV;
//     } else {
//       let ter = i + 1;
//       paymentDate.setMonth(startDate.getMonth() + ter);
//       paymentDate.setDate(0);
//       // paymentDate.setMonth(startDate.getMonth() + i);
//       const StartDate = new Date(startDate);
//       StartDate.setMonth(StartDate.getMonth() + i);

//       const endDate = new Date(paymentDate);
//       const getDaysDifference = (startDate, endDate) => {
//         const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
//         const firstDate = new Date(startDate);
//         const secondDate = new Date(endDate);

//         // Calculate the difference in milliseconds
//         const diffMilliseconds = Math.abs(firstDate - secondDate);

//         // If the dates are the same, return 1
//         if (diffMilliseconds === 0) {
//           return 1;
//         }

//         // Convert milliseconds to days and round the result
//         const diffDays = Math.round(diffMilliseconds / oneDay);
//         return diffDays;
//       };
//       // endDate.setMonth(paymentDate.getMonth());
//       // endDate.setDate(0); // Set to the last day of the current month
//       // let noOfDays = 0
//       if(isLastDayOfMonthh(startDate)){
//        noOfDays = getDaysDifference(StartDate, endDate);
//     }
//       else{
//        noOfDays = formulajs.DAYS360(StartDate, endDate);
//     }
//       // const noOfDays = formulajs.DAYS360(StartDate, endDate);
//       // const noOfDays = getDaysDifference(StartDate, endDate);
//       const incomeDate = new Date(endDate);
//       if (paymentFrequency === "Quarterly" && (i + 1) % 3 === 0) {
//         income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
//         paymentrentamount = 0;
//         if(paymentrentamount == 0 ){
//           capitalRecovery = 0 ;
//         }
//         else{
//           capitalRecovery = 0 - income;
//         }
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income + sumIncomeRecognized;


//       } else if (paymentFrequency === "Annual" && (i + 1) % 12 === 0) {
//         income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
//         paymentrentamount = 0;
//         if(paymentrentamount == 0 ){
//           capitalRecovery = 0 ;
//         }
//         else{
//           capitalRecovery = 0 - income;
//         }
//         // capitalRecovery = paymentAmount - income;
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income + sumIncomeRecognized;
//       } else if (paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0) {
//         income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
//         paymentrentamount = 0;
//         if(paymentrentamount == 0 ){
//           capitalRecovery = 0 ;
//         }
//         else{
//           capitalRecovery = 0 - income;
//         }
//         // capitalRecovery = paymentAmount - income;
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income + sumIncomeRecognized;
//       } else if (paymentFrequency === "Monthly") {
//         income = (((beginBV - 0) * dailyYield) / 100) * noOfDays;
//         paymentrentamount = 0;
//         if(paymentrentamount == 0 ){
//           capitalRecovery = 0 ;
//         }
//         else{
//           capitalRecovery = 0 - income;
//         }
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income + sumIncomeRecognized;
//       } else {
//         income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
//         paymentrentamount = 0;
//         if (paymentrentamount ==0){

//           capitalRecovery = 0 ;
//         }
//         else{
//           capitalRecovery = 0 - income;

//         }
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income + sumIncomeRecognized;


//       }
//       // const income =
//       //   (((beginBV - paymentAmount) * dailyYield) / 100) * noOfDays;
//       // const capitalRecovery = paymentAmount - income;
//       // const endBV = beginBV - capitalRecovery;
//       // const incomeRecognized = income;

//       schedule.push({
//         term: i,
//         // paymentDate: DatePicker(paymentDate),
//         paymentDate: DatePicker(endDate),
//         paymentAmount: paymentrentamount,
//         startDate: DatePicker(StartDate),
//         endDate: DatePicker(endDate),
//         noOfDays,
//         incomeDate: DatePicker(incomeDate),
//         beginBV,
//         income,
//         capitalRecovery,
//         endBV,
//         incomeRecognized,
//       });
//       Sumofincome +=income 

//       beginBV = endBV;
//       // let secondCapitalRecovery = 0
//       let capitalrecovery = 0

//       // Second schedule
//       const secondPaymentDate = new Date(startDate);
//       secondPaymentDate.setMonth(startDate.getMonth() + ter);
//       secondPaymentDate.setDate(secondPaymentDate.getDate());
//       // const StartDate = new Date(startDate)
//       // StartDate.setMonth(StartDate.getMonth() + i)
//       let laststart = new Date(StartDate);
//       laststart.setMonth(endDate.getMonth());
//       laststart.setDate(endDate.getDate() + 1);
//       const secondEndDate = new Date(secondPaymentDate);
//       secondEndDate.setMonth(secondEndDate.getMonth());
//       secondEndDate.setDate(secondEndDate.getDate() - 1);

//       const secondNoOfDays = 30 - noOfDays;
//       const secondIncomeDate = new Date(secondEndDate);

//       const secondIncome =
//       paymentFrequency === "Quarterly" && (i + 1) % 3 === 0
//       ? ((beginBV * dailyYield) / 100) * secondNoOfDays
//       : paymentFrequency === "Monthly" ?
//      ((beginBV * dailyYield) / 100) * secondNoOfDays
//       : paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0 ?
//      ((beginBV * dailyYield) / 100) * secondNoOfDays
//       : paymentFrequency === "Annual" && (i + 1) % 12 === 0 ?
//      ((beginBV * dailyYield) / 100) * secondNoOfDays


//       : ((beginBV * dailyYield) / 100) * secondNoOfDays;

//       const secondCapitalRecovery =
//         paymentFrequency === "Quarterly" && (i + 1) % 3 === 0
//           ? paymentAmount - (secondIncome * 3)
//           : paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0
//           ? paymentAmount - (secondIncome * 6)
//           : paymentFrequency === "Annual" && (i + 1) % 12 === 0
//           ? paymentAmount - (secondIncome * 12)
//           : paymentFrequency === "Monthly"
//           ? paymentAmount - (secondIncome)
//           : 0 - secondIncome;


//           // paymentrentamount = paymentAmount
//       if (paymentFrequency === "Quarterly" && (i + 1) % 3 === 0) {
//         paymentrentamount = paymentAmount;

//         capitalrecovery = paymentrentamount  - secondIncome -  Sumofincome
//         Sumofincome = 0
//       } else if (paymentFrequency === "Monthly") {
//         paymentrentamount = paymentAmount;
//         capitalrecovery = paymentrentamount - (secondIncome) - Sumofincome
//         Sumofincome = 0
//       } else if (paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0) {
//         paymentrentamount = paymentAmount;
//         capitalrecovery = paymentrentamount - (secondIncome ) - Sumofincome
//         Sumofincome = 0
//       } else if (paymentFrequency === "Annual" && (i + 1) % 12 === 0) {
//         paymentrentamount = paymentAmount;
//         capitalrecovery = paymentrentamount - (secondIncome) - Sumofincome
//         Sumofincome = 0
//       }
//       else{
//         Sumofincome += secondIncome
//       }
//       const secondEndBV = beginBV - capitalrecovery;
//       const secondIncomeRecognized = secondIncome;


//       schedule.push({
//         term: i,
//         // paymentDate: DatePicker(secondPaymentDate),
//         paymentDate: DatePicker(secondEndDate),
//         paymentAmount: paymentrentamount,
//         startDate: DatePicker(laststart),
//         endDate: DatePicker(secondEndDate),
//         noOfDays: secondNoOfDays,
//         incomeDate: DatePicker(secondIncomeDate),
//         beginBV,
//         income: secondIncome,
//         capitalRecovery: capitalrecovery,
//         endBV: secondEndBV,
//         incomeRecognized: "",
//       });

//       beginBV = secondEndBV;
//       sumIncomeRecognized = secondIncome;
//       // Sumofincome += schedule[schedule.length - 1].income
//     }
//   }
//   // if (residual > 0) {
//   //   const ResidualPaymentDate = new Date(schedule[schedule.length - 1].endDate);
//   //   ResidualPaymentDate.setDate(ResidualPaymentDate.getDate() + 1);

//   //   const ResidualEndDate = new Date(ResidualPaymentDate);
//   //   ResidualEndDate.setMonth(ResidualEndDate.getMonth() + 1);
//   //   ResidualEndDate.setDate(ResidualEndDate.getDate() - 1);

//   //   const ResidualNoOfDays = formulajs.DAYS360(
//   //     ResidualPaymentDate,
//   //     ResidualEndDate
//   //   );
//   //   const ResidualIncomeDate = new Date(ResidualEndDate);
//   //   const ResidualIncome =
//   //     (((beginBV - 0) * dailyYield) / 100) * ResidualNoOfDays;
//   //   const ResidualCapitalRecovery = 0 - ResidualIncome;
//   //   const ResidualEndBV = beginBV - ResidualCapitalRecovery;
//   //   const ResidualIncomeRecognized = ResidualIncome;
//   //   const ResidualbeginBV = schedule[schedule.length - 1].endBV;
//   //   schedule.push({
//   //     term: [1],
//   //     paymentDate: DatePicker(ResidualPaymentDate),
//   //     paymentAmount: 0,
//   //     startDate: DatePicker(ResidualPaymentDate),
//   //     endDate: DatePicker(ResidualEndDate),
//   //     noOfDays: ResidualNoOfDays,
//   //     incomeDate: DatePicker(ResidualIncomeDate),
//   //     beginBV: ResidualbeginBV,
//   //     income: ResidualIncome,
//   //     capitalRecovery: ResidualCapitalRecovery,
//   //     endBV: ResidualEndBV,
//   //     incomeRecognized: ResidualIncomeRecognized,
//   //   });
//   // }
//   return schedule;
// };


const generateArrearsSchedule = (
  startDate,
  numberOfPayments,
  financedAmount,
  paymentAmount,
  paymentFrequency,
  contractiir,
  residual
) => {
  const schedule = [];
  let beginBV = financedAmount;
  let income = 0;
  let capitalRecovery = 0;
  let endBV = 0;
  let incomeRecognized = 0;
  let paymentrentamount = paymentAmount;
  let sumIncomeRecognized = 0;
  startDate = new Date(startDate);
  let monthlyYield = contractiir / 12;
  let dailyYield = monthlyYield / 30;
  let Sumofincome = 0
  let noOfDays = 0

  for (let i = 0; i < numberOfPayments; i++) {
    const paymentDate = new Date(startDate);
    if (isFirstDayOfMonth(paymentDate)) {
      const term = i + 1;
      let paymentDate = new Date(startDate);
      paymentDate.setMonth(startDate.getMonth() + term);
      paymentDate.setDate(0);
      const endDate = new Date(paymentDate);
      const StartDate = new Date(startDate);
      StartDate.setMonth(StartDate.getMonth() + i);
      // paymentDate = new Date(endDate)
      // paymentDate.setMonth(endDate.getMonth())

      // alert(startDate)
      // endDate.setMonth(paymentDate.getMonth() + 1);
      // endDate.setDate(endDate.getDate() - 1); // Subtract one day
      const noOfDays = 30;
      const incomeDate = new Date(endDate);
      if (paymentFrequency === "Quarterly" && (i + 1) % 3 === 0) {
        income = ((beginBV - 0) * monthlyYield) / 100;
        capitalRecovery = paymentAmount - (income * 3)
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
        paymentrentamount = paymentAmount;
      } else if (paymentFrequency === "Monthly") {
        income = ((beginBV - 0) * monthlyYield) / 100;
        capitalRecovery = paymentAmount - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
      } else if (paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0) {
        income = ((beginBV - 0) * monthlyYield) / 100;
        capitalRecovery = paymentAmount - (income * 6);
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
        paymentrentamount = paymentAmount;
      } else if (paymentFrequency === "Annual" && (i + 1) % 12 === 0) {
        income = ((beginBV - 0) * monthlyYield) / 100;
        capitalRecovery = paymentAmount - (income * 12);
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
        paymentrentamount = paymentAmount;
      } else {
        income = ((beginBV - 0) * monthlyYield) / 100;
        paymentrentamount = 0;
        if (paymentrentamount == 0) {

          // capitalRecovery = 0 - income;
          capitalRecovery = 0;
        }
        else {
          capitalRecovery = 0 - income;

        }
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
      }
      paymentDate.setDate(endDate.getDate());
      schedule.push({
        term,
        // paymentDate: DatePicker(paymentDate),
        paymentDate: DatePicker(endDate),
        paymentAmount: paymentrentamount,
        startDate: DatePicker(StartDate),
        endDate: DatePicker(endDate),
        noOfDays,
        incomeDate: DatePicker(incomeDate),
        beginBV,
        income,
        capitalRecovery,
        endBV,
        incomeRecognized,
      });

      beginBV = endBV;
    } else {
      let ter = i + 1;
      const year = startDate.getFullYear();
      const isLeapYear =
        (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

      // paymentDate.setMonth(startDate.getMonth() + i);
      const StartDate = new Date(startDate);
      StartDate.setMonth(StartDate.getMonth() + i);
      let value = ""
      if (isLeapYear) {
        let nextMonth =
          StartDate.getMonth();
        if (nextMonth % 12 === 0) {

          paymentDate.setMonth(startDate.getMonth() + i);
          paymentDate.setDate(startDate.getDate());
        }
        else {
          if (nextMonth === 2) {
            if (value === 1) {

              value = 1
              paymentDate.setMonth(startDate.getMonth() + i);
              paymentDate.setDate(StartDate.getDate() - 1);
              value = ""
            }
            else {
              paymentDate.setMonth(startDate.getMonth() + i);
              paymentDate.setDate(StartDate.getDate());
              value = ""

            }

          }
          else {

            paymentDate.setMonth(startDate.getMonth() + ter);
            paymentDate.setDate(0);
          }
        }
        // endDate = new Date(
        //   startDate.getFullYear(),
        //   nextMonth,
        //   Math.min(startDate.getDate(), 29)
        // );
        // value = 1;
        // paymentDate.setMonth(startDate.getMonth() + i);
        // paymentDate.setDate(startDate.getDate());
      }
      else {

        paymentDate.setMonth(startDate.getMonth() + ter);
        paymentDate.setDate(0);
      }
      const endDate = new Date(paymentDate);
      if (isLeapYear) {
        let nextMonth =
          StartDate.getMonth();
        if (nextMonth % 12 === 1) {

          endDate.setDate(endDate.getDate() + 1)
        }
        else {
          // endDate.setMonth(endDate.getMonth()-1)
          endDate.setDate(endDate.getDate())

        }
        // endDate = new Date(
        //   startDate.getFullYear(),
        //   nextMonth,
        //   Math.min(startDate.getDate(), 29)
        // );
        // value = 1;

      }
      else {

        // endDate.setMonth(endDate.getMonth()-1)

        endDate.setDate(endDate.getDate())
      }
      const getDaysDifference = (startDate, endDate) => {
        const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        const firstDate = new Date(startDate);
        const secondDate = new Date(endDate);

        // Calculate the difference in milliseconds
        const diffMilliseconds = Math.abs(firstDate - secondDate);

        // If the dates are the same, return 1
        if (diffMilliseconds === 0) {
          return 1;
        }

        // Convert milliseconds to days and round the result
        const diffDays = Math.round(diffMilliseconds / oneDay);
        return diffDays;
      };
      // endDate.setMonth(paymentDate.getMonth());
      // endDate.setDate(0); // Set to the last day of the current month
      // let noOfDays = 0
      if (isLastDayOfMonthh(startDate)) {
        noOfDays = getDaysDifference(StartDate, endDate);
      }
      else {
        noOfDays = formulajs.DAYS360(StartDate, endDate);
      }
      // const noOfDays = formulajs.DAYS360(StartDate, endDate);
      // const noOfDays = getDaysDifference(StartDate, endDate);
      const incomeDate = new Date(endDate);
      if (paymentFrequency === "Quarterly" && (i + 1) % 3 === 0) {
        income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
        paymentrentamount = 0;
        if (paymentrentamount == 0) {
          capitalRecovery = 0;
        }
        else {
          capitalRecovery = 0 - income;
        }
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;


      } else if (paymentFrequency === "Annual" && (i + 1) % 12 === 0) {
        income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
        paymentrentamount = 0;
        if (paymentrentamount == 0) {
          capitalRecovery = 0;
        }
        else {
          capitalRecovery = 0 - income;
        }
        // capitalRecovery = paymentAmount - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;
      } else if (paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0) {
        income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
        paymentrentamount = 0;
        if (paymentrentamount == 0) {
          capitalRecovery = 0;
        }
        else {
          capitalRecovery = 0 - income;
        }
        // capitalRecovery = paymentAmount - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;
      } else if (paymentFrequency === "Monthly") {
        income = (((beginBV - 0) * dailyYield) / 100) * noOfDays;
        paymentrentamount = 0;
        if (paymentrentamount == 0) {
          capitalRecovery = 0;
        }
        else {
          capitalRecovery = 0 - income;
        }
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;
      } else {
        income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
        paymentrentamount = 0;
        if (paymentrentamount == 0) {

          capitalRecovery = 0;
        }
        else {
          capitalRecovery = 0 - income;

        }
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;


      }
      // const income =
      //   (((beginBV - paymentAmount) * dailyYield) / 100) * noOfDays;
      // const capitalRecovery = paymentAmount - income;
      // const endBV = beginBV - capitalRecovery;
      // const incomeRecognized = income;

      schedule.push({
        term: i,
        paymentDate: DatePicker(paymentDate),
        // paymentDate: DatePicker(endDate),
        paymentAmount: paymentrentamount,
        startDate: DatePicker(StartDate),
        endDate: DatePicker(endDate),
        noOfDays,
        incomeDate: DatePicker(incomeDate),
        beginBV,
        income,
        capitalRecovery,
        endBV,
        incomeRecognized,
      });
      Sumofincome += income

      beginBV = endBV;
      // let secondCapitalRecovery = 0
      let capitalrecovery = 0
      let secondPaymentDate = ""
      // Second schedule
      const secondyear = StartDate.getFullYear();
      const isSecondLeapYear =
        (secondyear % 4 === 0 && secondyear % 100 !== 0) || secondyear % 400 === 0;
      let nextMonth =
        StartDate.getMonth();
      let lastDayNextMonth = new Date(
        startDate.getFullYear(),
        nextMonth + 1,
        0
      ).getDate();
      if (nextMonth % 12 === 0) {
        if (isSecondLeapYear) {
          // endDate = new Date(
          //   startDate.getFullYear(),
          //   nextMonth,
          //   Math.min(startDate.getDate(), 29)
          // );
          // value = 1;
          secondPaymentDate = new Date(startDate);
          secondPaymentDate.setMonth(startDate.getMonth() + ter);
          secondPaymentDate.setDate(secondPaymentDate.getDate() - 1);
        }
        else {
          secondPaymentDate = new Date(StartDate.getFullYear(),
            (StartDate.getMonth() + 1),
            Math.min(startDate.getDate() - 1, 29)
          );
          // secondPaymentDate.setMonth(StartDate.getMonth()+1);

          // secondPaymentDate.setDate(secondPaymentDate.getDate() -1);
        }
      }
      else {
        secondPaymentDate = new Date(startDate);
        secondPaymentDate.setMonth(startDate.getMonth() + ter);
        secondPaymentDate.setDate(secondPaymentDate.getDate());

      }

      // if (isSecondLeapYear) {
      //   // endDate = new Date(
      //   //   startDate.getFullYear(),
      //   //   nextMonth,
      //   //   Math.min(startDate.getDate(), 29)
      //   // );
      //   // value = 1;
      //    secondPaymentDate = new Date(startDate);
      // secondPaymentDate.setMonth(startDate.getMonth() + ter);
      // secondPaymentDate.setDate(secondPaymentDate.getDate());
      // }
      // else{
      //    secondPaymentDate = new Date(startDate);
      //   secondPaymentDate.setMonth(startDate.getMonth() + ter);
      //   secondPaymentDate.setDate(secondPaymentDate.getDate());
      // }
      // const secondPaymentDate = new Date(startDate);
      // secondPaymentDate.setMonth(startDate.getMonth() + ter);
      // secondPaymentDate.setDate(secondPaymentDate.getDate());
      // const StartDate = new Date(startDate)
      // StartDate.setMonth(StartDate.getMonth() + i)

      // let laststart = new Date(StartDate);
      let laststart = new Date(StartDate);
      // laststart.setMonth(endDate.getMonth());
      // laststart.setDate(endDate.getDate() + 1);
      if (nextMonth % 12 === 0) {
        if (isSecondLeapYear) {
          laststart.setMonth(endDate.getMonth());
          laststart.setDate(endDate.getDate() + 1);
        }
        else {

          laststart.setMonth(endDate.getMonth());
          laststart.setDate(endDate.getDate() + 1);

        }
      }
      else {
        laststart.setMonth(endDate.getMonth());
        laststart.setDate(endDate.getDate() + 1);

      }
      const secondEndDate = new Date(secondPaymentDate);
      secondEndDate.setMonth(secondEndDate.getMonth());
      secondEndDate.setDate(secondEndDate.getDate() - 1);

      const secondNoOfDays = 30 - noOfDays;
      const secondIncomeDate = new Date(secondEndDate);

      const secondIncome =
        paymentFrequency === "Quarterly" && (i + 1) % 3 === 0
          ? ((beginBV * dailyYield) / 100) * secondNoOfDays
          : paymentFrequency === "Monthly" ?
            ((beginBV * dailyYield) / 100) * secondNoOfDays
            : paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0 ?
              ((beginBV * dailyYield) / 100) * secondNoOfDays
              : paymentFrequency === "Annual" && (i + 1) % 12 === 0 ?
                ((beginBV * dailyYield) / 100) * secondNoOfDays


                : ((beginBV * dailyYield) / 100) * secondNoOfDays;

      const secondCapitalRecovery =
        paymentFrequency === "Quarterly" && (i + 1) % 3 === 0
          ? paymentAmount - (secondIncome * 3)
          : paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0
            ? paymentAmount - (secondIncome * 6)
            : paymentFrequency === "Annual" && (i + 1) % 12 === 0
              ? paymentAmount - (secondIncome * 12)
              : paymentFrequency === "Monthly"
                ? paymentAmount - (secondIncome)
                : 0 - secondIncome;


      // paymentrentamount = paymentAmount
      if (paymentFrequency === "Quarterly" && (i + 1) % 3 === 0) {
        paymentrentamount = paymentAmount;

        capitalrecovery = paymentrentamount - secondIncome - Sumofincome
        Sumofincome = 0
      } else if (paymentFrequency === "Monthly") {
        paymentrentamount = paymentAmount;
        capitalrecovery = paymentrentamount - (secondIncome) - Sumofincome
        Sumofincome = 0
      } else if (paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0) {
        paymentrentamount = paymentAmount;
        capitalrecovery = paymentrentamount - (secondIncome) - Sumofincome
        Sumofincome = 0
      } else if (paymentFrequency === "Annual" && (i + 1) % 12 === 0) {
        paymentrentamount = paymentAmount;
        capitalrecovery = paymentrentamount - (secondIncome) - Sumofincome
        Sumofincome = 0
      }
      else {
        Sumofincome += secondIncome
      }
      const secondEndBV = beginBV - capitalrecovery;
      const secondIncomeRecognized = secondIncome;


      schedule.push({
        term: i,
        // paymentDate: DatePicker(secondPaymentDate),
        paymentDate: DatePicker(secondEndDate),
        paymentAmount: paymentrentamount,
        startDate: DatePicker(laststart),
        endDate: DatePicker(secondEndDate),
        noOfDays: secondNoOfDays,
        incomeDate: DatePicker(secondIncomeDate),
        beginBV,
        income: secondIncome,
        capitalRecovery: capitalrecovery,
        endBV: secondEndBV,
        incomeRecognized: "",
      });

      beginBV = secondEndBV;
      sumIncomeRecognized = secondIncome;
      // Sumofincome += schedule[schedule.length - 1].income
    }
  }
  // if (residual > 0) {
  //   const ResidualPaymentDate = new Date(schedule[schedule.length - 1].endDate);
  //   ResidualPaymentDate.setDate(ResidualPaymentDate.getDate() + 1);

  //   const ResidualEndDate = new Date(ResidualPaymentDate);
  //   ResidualEndDate.setMonth(ResidualEndDate.getMonth() + 1);
  //   ResidualEndDate.setDate(ResidualEndDate.getDate() - 1);

  //   const ResidualNoOfDays = formulajs.DAYS360(
  //     ResidualPaymentDate,
  //     ResidualEndDate
  //   );
  //   const ResidualIncomeDate = new Date(ResidualEndDate);
  //   const ResidualIncome =
  //     (((beginBV - 0) * dailyYield) / 100) * ResidualNoOfDays;
  //   const ResidualCapitalRecovery = 0 - ResidualIncome;
  //   const ResidualEndBV = beginBV - ResidualCapitalRecovery;
  //   const ResidualIncomeRecognized = ResidualIncome;
  //   const ResidualbeginBV = schedule[schedule.length - 1].endBV;
  //   schedule.push({
  //     term: [1],
  //     paymentDate: DatePicker(ResidualPaymentDate),
  //     paymentAmount: 0,
  //     startDate: DatePicker(ResidualPaymentDate),
  //     endDate: DatePicker(ResidualEndDate),
  //     noOfDays: ResidualNoOfDays,
  //     incomeDate: DatePicker(ResidualIncomeDate),
  //     beginBV: ResidualbeginBV,
  //     income: ResidualIncome,
  //     capitalRecovery: ResidualCapitalRecovery,
  //     endBV: ResidualEndBV,
  //     incomeRecognized: ResidualIncomeRecognized,
  //   });
  // }
  return schedule;
};

// const generateLeaseArrearsSchedule = (
//   startDate,
//   numberOfPayments,
//   financedAmount,
//   paymentAmount,
//   paymentFrequency,
//   contractiir,
//   residual
// ) => {
//   const schedule = [];
//   let beginBV = financedAmount;
//   let income = 0;
//   let capitalRecovery = 0;
//   let endBV = 0;
//   let incomeRecognized = 0;
//   // let paymentrentamount = paymentAmount;
//   let sumIncomeRecognized = 0;
//   startDate = new Date(startDate);
//   let monthlyYield = contractiir / 12;
//   let dailyYield = monthlyYield / 30;

//   for (let i = 0; i < numberOfPayments; i++) {
//     const paymentDate = new Date(startDate);
//     if (isFirstDayOfMonth(paymentDate)) {
//       const term = i + 1;
//       let paymentDate = new Date(startDate);
//       paymentDate.setMonth(startDate.getMonth() + term);
//       paymentDate.setDate(0);
//       const endDate = new Date(paymentDate);
//       const StartDate = new Date(startDate);
//       StartDate.setMonth(StartDate.getMonth() + i);
//       // paymentDate = new Date(endDate)
//       // paymentDate.setMonth(endDate.getMonth())

//       // alert(startDate)
//       // endDate.setMonth(paymentDate.getMonth() + 1);
//       // endDate.setDate(endDate.getDate() - 1); // Subtract one day
//       const noOfDays = 30;
//       const incomeDate = new Date(endDate);
//       if (paymentFrequency === "Quarterly" && (i + 1) % 3 === 0) {
//         income = ((beginBV - 0) * monthlyYield) / 100;
//         capitalRecovery = paymentAmount - income;
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income;
//         paymentrentamount = paymentAmount;
//       } else if (paymentFrequency === "Monthly") {
//         income = ((beginBV - 0) * monthlyYield) / 100;
//         capitalRecovery = paymentAmount - income;
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income;
//       } else if (paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0) {
//         income = ((beginBV - 0) * monthlyYield) / 100;
//         capitalRecovery = paymentAmount - income;
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income;
//         paymentrentamount = paymentAmount;
//       } else if (paymentFrequency === "Annual" && (i + 1) % 12 === 0) {
//         income = ((beginBV - 0) * monthlyYield) / 100;
//         capitalRecovery = paymentAmount - income;
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income;
//         paymentrentamount = paymentAmount;
//       } else {
//         income = ((beginBV - 0) * monthlyYield) / 100;
//         capitalRecovery = 0 - income;
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income;
//         paymentrentamount = 0;
//       }
//       paymentDate.setDate(endDate.getDate());
//       schedule.push({
//         term,
//         // paymentDate: DatePicker(paymentDate),
//         paymentDate: DatePicker(endDate),
//         paymentAmount: paymentrentamount,
//         startDate: DatePicker(StartDate),
//         endDate: DatePicker(endDate),
//         noOfDays,
//         incomeDate: DatePicker(incomeDate),
//         beginBV,
//         income,
//         capitalRecovery,
//         endBV,
//         incomeRecognized,
//       });

//       beginBV = endBV;
//     } else {
//       let ter = i + 1;
//       paymentDate.setMonth(startDate.getMonth() + ter);
//       paymentDate.setDate(0);
//       const StartDate = new Date(startDate);
//       StartDate.setMonth(StartDate.getMonth() + i);

//       const endDate = new Date(paymentDate);
//       const noOfDays = formulajs.DAYS360(StartDate, endDate);
//       const incomeDate = new Date(endDate);
//       if (paymentFrequency === "Quarterly" && (i + 1) % 3 === 0) {
//         income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
//         if (isLastDayOfMonthh(incomeDate)) {
//           capitalRecovery = 0;
//         } else {
//           capitalRecovery =
//             paymentAmount - income - schedule[schedule.length - 1].income;
//         }
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income + sumIncomeRecognized;
//         paymentrentamount = 0;
//       } else if (paymentFrequency === "Annual" && (i + 1) % 12 === 0) {
//         income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
//         if (isLastDayOfMonthh(incomeDate)) {
//           capitalRecovery = 0 - 0;
//         } else {
//           capitalRecovery = paymentAmount - income;
//         }
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income + sumIncomeRecognized;
//         paymentrentamount = 0;
//       } else if (paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0) {
//         income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
//         if (isLastDayOfMonthh(incomeDate)) {
//           capitalRecovery = 0 - 0;
//         } else {
//           capitalRecovery = paymentAmount - income;
//         }
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income + sumIncomeRecognized;
//         paymentrentamount = 0;
//       } else if (paymentFrequency === "Monthly") {
//         income = (((beginBV - 0) * dailyYield) / 100) * noOfDays;
//         if (isLastDayOfMonthh(incomeDate)) {
//           capitalRecovery = 0;
//         } else {
//           capitalRecovery = paymentAmount - income;
//         }
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income + sumIncomeRecognized;
//         paymentrentamount = 0;
//       } else {
//         income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
//         if (paymentFrequency === "Monthly") {
//           if (isLastDayOfMonthh(incomeDate)) {
//             capitalRecovery = 0;
//           } else {
//             capitalRecovery = paymentAmount - income;
//           }
//         }
//         if (paymentFrequency === "Quarterly") {
//           if (isLastDayOfMonthh(incomeDate)) {
//             capitalRecovery = 0 - 0;
//           } else {
//             capitalRecovery = paymentAmount - income;
//           }
//         }
//         if (paymentFrequency === "Semi-annual") {
//           if (isLastDayOfMonthh(incomeDate)) {
//             capitalRecovery = 0 - 0;
//           } else {
//             capitalRecovery = paymentAmount - income;
//           }
//         }
//         if (paymentFrequency === "Annual") {
//           if (isLastDayOfMonthh(incomeDate)) {
//             capitalRecovery = 0 - 0;
//           } else {
//             capitalRecovery = paymentAmount - income;
//           }
//         }
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income + sumIncomeRecognized;
//         paymentrentamount = 0;
//       }
//       schedule.push({
//         term: i,
//         paymentDate: DatePicker(endDate),
//         paymentAmount: paymentrentamount,
//         startDate: DatePicker(StartDate),
//         endDate: DatePicker(endDate),
//         noOfDays,
//         incomeDate: DatePicker(incomeDate),
//         beginBV,
//         income,
//         capitalRecovery,
//         endBV,
//         incomeRecognized,
//       });

//       beginBV = endBV;

//       // Second schedule
//       const secondPaymentDate = new Date(startDate);
//       secondPaymentDate.setMonth(startDate.getMonth() + ter);
//       secondPaymentDate.setDate(secondPaymentDate.getDate());
//       let laststart = new Date(StartDate);
//       laststart.setMonth(endDate.getMonth());
//       laststart.setDate(endDate.getDate() + 1);
//       const secondEndDate = new Date(secondPaymentDate);
//       secondEndDate.setMonth(secondEndDate.getMonth());
//       secondEndDate.setDate(secondEndDate.getDate() - 1);

//       const secondNoOfDays = 30 - noOfDays;
//       const secondIncomeDate = new Date(secondEndDate);
//       const secondIncome =
//         paymentFrequency === "Quarterly" && (i + 1) % 3 === 0
//           ? ((beginBV * dailyYield) / 100) * secondNoOfDays
//           : ((beginBV * dailyYield) / 100) * secondNoOfDays;
//       if (paymentFrequency === "Monthly") {
//         if (isLastDayOfMonthh(secondIncomeDate)) {
//           capitalRecovery = 0 - -0;
//         } else {
//           capitalRecovery =
//             paymentAmount - secondIncome - schedule[schedule.length - 1].income;
//         }
//       }
//       const secondCapitalRecovery =
//         paymentFrequency === "Quarterly" && (i + 1) % 3 === 0
//           ? paymentAmount - secondIncome
//           : paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0
//           ? paymentAmount - secondIncome
//           : paymentFrequency === "Annual" && (i + 1) % 12 === 0
//           ? paymentAmount - secondIncome
//           : paymentFrequency === "Monthly"
//           ? paymentAmount - secondIncome
//           : 0 - secondIncome;

//       // paymentrentamount = paymentAmount
//       if (paymentFrequency === "Quarterly" && (i + 1) % 3 === 0) {
//         paymentrentamount = paymentAmount;
//       } else if (paymentFrequency === "Monthly") {
//         paymentrentamount = paymentAmount;
//       } else if (paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0) {
//         paymentrentamount = paymentAmount;
//       } else if (paymentFrequency === "Annual" && (i + 1) % 12 === 0) {
//         paymentrentamount = paymentAmount;
//       } else {
//         paymentrentamount = 0;
//       }

//       if (paymentFrequency !== "Monthly") {
//         if (isLastDayOfMonthh(secondIncomeDate)) {
//           capitalRecovery = 0 - -0;
//         } else {
//           if (paymentrentamount !== 0) {
//             capitalRecovery =
//               paymentAmount -
//               secondIncome -
//               schedule[schedule.length - 1].income;
//           } else {
//             capitalRecovery =
//               0 - secondIncome - schedule[schedule.length - 1].income;
//           }
//         }
//       }

//       const secondEndBV = beginBV - capitalRecovery;
//       const secondIncomeRecognized = secondIncome;

//       schedule.push({
//         term: i,
//         paymentDate: DatePicker(secondEndDate),
//         paymentAmount: paymentrentamount,
//         startDate: DatePicker(laststart),
//         endDate: DatePicker(secondEndDate),
//         noOfDays: secondNoOfDays,
//         incomeDate: DatePicker(secondIncomeDate),
//         beginBV,
//         income: secondIncome,
//         capitalRecovery: capitalRecovery,
//         endBV: secondEndBV,
//         incomeRecognized: "",
//       });

//       beginBV = secondEndBV;
//       sumIncomeRecognized = secondIncome;
//     }
//   }
//   return schedule;
// };

const generateLeaseArrearsSchedule = (
  startDate,
  numberOfPayments,
  financedAmount,
  paymentAmount,
  paymentFrequency,
  contractiir,
  residual
) => {
  const schedule = [];
  let beginBV = financedAmount;
  let income = 0;
  let capitalRecovery = 0;
  let endBV = 0;
  let incomeRecognized = 0;
  // let paymentrentamount = paymentAmount;
  let sumIncomeRecognized = 0;
  startDate = new Date(startDate);
  let monthlyYield = contractiir / 12;
  let dailyYield = monthlyYield / 30;
  const frequencyMapping = {
    Monthly: 1,
    Quarterly: 3,
    "Semi-annual": 6,
    Annual: 12,
  };
  for (let i = 0; i < numberOfPayments; i++) {
    const paymentDate = new Date(startDate);
    if (isFirstDayOfMonth(paymentDate)) {
      const term = i + 1;
      let paymentDate = new Date(startDate);
      paymentDate.setMonth(startDate.getMonth() + term);
      // paymentDate.setDate(startDate.getDate());
      // paymentDate.setDate(0);
      // const endDate = new Date(paymentDate);
      const endDate = new Date(paymentDate);
      endDate.setDate(0); // Subtract one day
      const StartDate = new Date(startDate);
      StartDate.setMonth(StartDate.getMonth() + i);
      // paymentDate = new Date(endDate)
      // paymentDate.setMonth(endDate.getMonth())

      // alert(startDate)
      // endDate.setMonth(paymentDate.getMonth() + 1);
      // endDate.setDate(endDate.getDate() - 1); // Subtract one day
      const noOfDays = 30;
      const incomeDate = new Date(endDate);

      let paymentrentamount = paymentAmount[i]

      if (paymentFrequency === "Quarterly" && (i + 1) % 3 === 0) {
        income = ((beginBV - 0) * monthlyYield) / 100;
        capitalRecovery = paymentAmount[i] - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
        paymentrentamount = paymentAmount[i];
      } else if (paymentFrequency === "Monthly") {
        income = ((beginBV - 0) * monthlyYield) / 100;
        capitalRecovery = paymentAmount[i] - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
      } else if (paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0) {
        income = ((beginBV - 0) * monthlyYield) / 100;
        capitalRecovery = paymentAmount[i] - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
        paymentrentamount = paymentAmount[i];
      } else if (paymentFrequency === "Annual" && (i + 1) % 12 === 0) {
        income = ((beginBV - 0) * monthlyYield) / 100;
        capitalRecovery = paymentAmount[i] - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
        paymentrentamount = paymentAmount[i];
      } else {
        income = ((beginBV - 0) * monthlyYield) / 100;
        capitalRecovery = 0 - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
        paymentrentamount = 0;
      }
      // paymentDate.setDate(endDate.getDate());
      schedule.push({
        term,
        paymentDate: DatePicker(paymentDate),
        // paymentDate: DatePicker(endDate),
        paymentAmount: paymentrentamount,
        startDate: DatePicker(StartDate),
        endDate: DatePicker(endDate),
        noOfDays,
        incomeDate: DatePicker(incomeDate),
        beginBV,
        income,
        capitalRecovery,
        endBV,
        incomeRecognized,
      });

      beginBV = endBV;
    } else {
      let ter = i + 1;
      paymentDate.setMonth(startDate.getMonth() + ter);
      // paymentDate.setDate(0);
      paymentDate.setDate(0);
      const StartDate = new Date(startDate);
      StartDate.setMonth(StartDate.getMonth() + i);

      // const endDate = new Date(paymentDate);
      const endDate = new Date(paymentDate);
      // endDate.setDate(endDate.getDate()-1)
      const noOfDays = formulajs.DAYS360(StartDate, endDate);
      const incomeDate = new Date(endDate);

      let paymentrentamount = paymentAmount[i]

      if (paymentFrequency === "Quarterly" && (i + 1) % 3 === 0) {
        income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
        if (isLastDayOfMonthh(incomeDate)) {
          capitalRecovery = 0;
        } else {
          capitalRecovery =
            paymentAmount[i] - income - schedule[schedule.length - 1].income;
        }
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;
        paymentrentamount = 0;
      } else if (paymentFrequency === "Annual" && (i + 1) % 12 === 0) {
        income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
        if (isLastDayOfMonthh(incomeDate)) {
          capitalRecovery = 0 - 0;
        } else {
          capitalRecovery = paymentAmount[i] - income;
        }
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;
        paymentrentamount = 0;
      } else if (paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0) {
        income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
        if (isLastDayOfMonthh(incomeDate)) {
          capitalRecovery = 0 - 0;
        } else {
          capitalRecovery = paymentAmount[i] - income;
        }
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;
        paymentrentamount = 0;
      } else if (paymentFrequency === "Monthly") {
        income = (((beginBV - 0) * dailyYield) / 100) * noOfDays;
        if (isLastDayOfMonthh(incomeDate)) {
          capitalRecovery = 0;
        } else {
          capitalRecovery = paymentAmount[i] - income;
        }
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;
        paymentrentamount = 0;
      } else {
        income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
        if (paymentFrequency === "Monthly") {
          if (isLastDayOfMonthh(incomeDate)) {
            capitalRecovery = 0;
          } else {
            capitalRecovery = paymentAmount[i] - income;
          }
        }
        if (paymentFrequency === "Quarterly") {
          if (isLastDayOfMonthh(incomeDate)) {
            capitalRecovery = 0 - 0;
          } else {
            capitalRecovery = paymentAmount[i] - income;
          }
        }
        if (paymentFrequency === "Semi-annual") {
          if (isLastDayOfMonthh(incomeDate)) {
            capitalRecovery = 0 - 0;
          } else {
            capitalRecovery = paymentAmount[i] - income;
          }
        }
        if (paymentFrequency === "Annual") {
          if (isLastDayOfMonthh(incomeDate)) {
            capitalRecovery = 0 - 0;
          } else {
            capitalRecovery = paymentAmount[i] - income;
          }
        }
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;
        paymentrentamount = 0;
      }
      schedule.push({
        term: i,
        paymentDate: DatePicker(endDate),
        // paymentDate: DatePicker(paymentDate),
        paymentAmount: paymentrentamount,
        startDate: DatePicker(StartDate),
        endDate: DatePicker(endDate),
        noOfDays,
        incomeDate: DatePicker(incomeDate),
        beginBV,
        income,
        capitalRecovery,
        endBV,
        incomeRecognized,
      });

      beginBV = endBV;

      // Second schedule
      const secondPaymentDate = new Date(startDate);
      secondPaymentDate.setMonth(startDate.getMonth() + ter);
      secondPaymentDate.setDate(secondPaymentDate.getDate());
      let laststart = new Date(StartDate);
      laststart.setMonth(endDate.getMonth());
      laststart.setDate(endDate.getDate() + 1);
      const secondEndDate = new Date(secondPaymentDate);
      secondEndDate.setMonth(secondEndDate.getMonth());
      secondEndDate.setDate(secondEndDate.getDate() - 1);

      const secondNoOfDays = 30 - noOfDays;
      const secondIncomeDate = new Date(secondEndDate);
      const secondIncome =
        paymentFrequency === "Quarterly" && (i + 1) % 3 === 0
          ? ((beginBV * dailyYield) / 100) * secondNoOfDays
          : ((beginBV * dailyYield) / 100) * secondNoOfDays;
      if (paymentFrequency === "Monthly") {
        if (isLastDayOfMonthh(secondIncomeDate)) {
          capitalRecovery = 0 - -0;
        } else {
          capitalRecovery =
            paymentAmount[i] - secondIncome - schedule[schedule.length - 1].income;
        }
      }
      const secondCapitalRecovery =
        paymentFrequency === "Quarterly" && (i + 1) % 3 === 0
          ? paymentAmount[i] - secondIncome
          : paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0
            ? paymentAmount[i] - secondIncome
            : paymentFrequency === "Annual" && (i + 1) % 12 === 0
              ? paymentAmount[i] - secondIncome
              : paymentFrequency === "Monthly"
                ? paymentAmount[i] - secondIncome
                : 0 - secondIncome;

      // paymentrentamount = paymentAmount
      if (paymentFrequency === "Quarterly" && (i + 1) % 3 === 0) {
        paymentrentamount = paymentAmount[i];
      } else if (paymentFrequency === "Monthly") {
        paymentrentamount = paymentAmount[i];
      } else if (paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0) {
        paymentrentamount = paymentAmount[i];
      } else if (paymentFrequency === "Annual" && (i + 1) % 12 === 0) {
        paymentrentamount = paymentAmount[i];
      } else {
        paymentrentamount = 0;
      }

      if (paymentFrequency !== "Monthly") {
        if (isLastDayOfMonthh(secondIncomeDate)) {
          capitalRecovery = 0 - -0;
        } else {
          if (paymentrentamount !== 0) {
            capitalRecovery =
              paymentAmount[i] -
              secondIncome -
              schedule[schedule.length - 1].income;
          } else {
            capitalRecovery =
              0 - secondIncome - schedule[schedule.length - 1].income;
          }
        }
      }

      const secondEndBV = beginBV - capitalRecovery;
      const secondIncomeRecognized = secondIncome;

      schedule.push({
        term: i,
        // paymentDate: DatePicker(secondEndDate),
        paymentDate: DatePicker(secondPaymentDate),
        paymentAmount: paymentrentamount,
        startDate: DatePicker(laststart),
        endDate: DatePicker(secondEndDate),
        noOfDays: secondNoOfDays,
        incomeDate: DatePicker(secondIncomeDate),
        beginBV,
        income: secondIncome,
        capitalRecovery: capitalRecovery,
        endBV: secondEndBV,
        incomeRecognized: "",
      });

      beginBV = secondEndBV;
      sumIncomeRecognized = secondIncome;
    }
  }
  return schedule;
};

const generateLeaseSchedule = (
  startDate,
  numberOfPayments,
  financedAmount,
  paymentAmount,
  paymentFrequency,
  contractiir,
  residual
) => {
  const schedule = [];
  let beginBV = financedAmount;
  let income = 0;
  let capitalRecovery = 0;
  let endBV = 0;
  let incomeRecognized = 0;
  // let paymentrentamount = paymentAmount;
  let sumIncomeRecognized = 0;
  startDate = new Date(startDate);
  let monthlyYield = contractiir / 12;
  let dailyYield = monthlyYield / 30;

  for (let i = 0; i < numberOfPayments; i++) {
    const paymentDate = new Date(startDate);
    if (isFirstDayOfMonth(paymentDate)) {
      const term = i + 1;
      const paymentDate = new Date(startDate);
      paymentDate.setMonth(startDate.getMonth() + i);
      const endDate = new Date(paymentDate);
      endDate.setMonth(paymentDate.getMonth() + 1);
      endDate.setDate(endDate.getDate() - 1); // Subtract one day
      const noOfDays = 30;
      const incomeDate = new Date(endDate);

      let paymentrentamount = paymentAmount[i];


      if (paymentFrequency === "Quarterly" && i % 3 === 0) {
        income = ((beginBV - paymentAmount[i]) * monthlyYield) / 100;
        capitalRecovery = paymentAmount[i] - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
        paymentrentamount = paymentAmount[i];
      } else if (paymentFrequency === "Monthly") {
        income = ((beginBV - paymentAmount[i]) * monthlyYield) / 100;
        capitalRecovery = paymentAmount[i] - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
      } else if (paymentFrequency === "Semi-annual" && i % 6 === 0) {
        income = ((beginBV - paymentAmount[i]) * monthlyYield) / 100;
        capitalRecovery = paymentAmount[i] - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
      } else if (paymentFrequency === "Annual" && i % 12 === 0) {
        income = ((beginBV - paymentAmount[i]) * monthlyYield) / 100;
        capitalRecovery = paymentAmount[i] - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
      } else {
        income = ((beginBV - 0) * monthlyYield) / 100;
        capitalRecovery = 0 - income;
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income;
        paymentrentamount = 0;
      }

      schedule.push({
        term,
        paymentDate: DatePicker(paymentDate),
        paymentAmount: paymentrentamount,
        startDate: DatePicker(paymentDate),
        endDate: DatePicker(endDate),
        noOfDays,
        incomeDate: DatePicker(incomeDate),
        beginBV,
        income,
        capitalRecovery,
        endBV,
        incomeRecognized,
      });

      beginBV = endBV;
    } else {
      paymentDate.setMonth(startDate.getMonth() + i);

      const endDate = new Date(paymentDate);
      endDate.setMonth(paymentDate.getMonth() + 1);
      endDate.setDate(0); // Set to the last day of the current month
      const noOfDays = formulajs.DAYS360(paymentDate, endDate);
      const incomeDate = new Date(endDate);

      let paymentrentamount = paymentAmount[i]


      if (paymentFrequency === "Quarterly" && i % 3 === 0) {
        income = ((beginBV - paymentAmount[i]) * dailyYield * noOfDays) / 100;
        if (isLastDayOfMonthh(incomeDate)) {
          capitalRecovery = paymentAmount[i] - (-0);
        } else {
          capitalRecovery = paymentAmount[i] - income;
        }
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;
        paymentrentamount = paymentAmount[i];
      } else if (paymentFrequency === "Annual" && i % 12 === 0) {
        income = ((beginBV - paymentAmount[i]) * dailyYield * noOfDays) / 100;
        if (isLastDayOfMonthh(incomeDate)) {
          capitalRecovery = paymentAmount[i] - (-0);
        } else {
          capitalRecovery = paymentAmount[i] - income;
        }
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;
        paymentrentamount = paymentAmount[i];
      } else if (paymentFrequency === "Semi-annual" && i % 6 === 0) {
        income = ((beginBV - paymentAmount[i]) * dailyYield * noOfDays) / 100;
        if (isLastDayOfMonthh(incomeDate)) {
          capitalRecovery = paymentAmount[i] - (-0);
        } else {
          capitalRecovery = paymentAmount[i] - income;
        }
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;
        paymentrentamount = paymentAmount[i];
      } else if (paymentFrequency === "Monthly") {
        income = (((beginBV - paymentAmount[i]) * dailyYield) / 100) * noOfDays;
        if (isLastDayOfMonthh(incomeDate)) {
          capitalRecovery = paymentAmount[i] - (-0);
        } else {
          capitalRecovery = paymentAmount[i] - income;
        }
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;
        paymentrentamount = paymentAmount[i];
      } else {
        income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
        if (paymentFrequency === "Monthly") {
          if (isLastDayOfMonthh(incomeDate)) {
            capitalRecovery = paymentAmount[i] - income;
          } else {
            capitalRecovery = paymentAmount[i] - (-0);
          }
        }
        if (paymentFrequency === "Quarterly") {
          if (isLastDayOfMonthh(incomeDate)) {
            capitalRecovery = 0 - 0;
          } else {
            capitalRecovery = paymentAmount[i] - (-0);
          }
        }
        if (paymentFrequency === "Semi-annual") {
          if (isLastDayOfMonthh(incomeDate)) {
            capitalRecovery = 0 - 0;
          } else {
            capitalRecovery = paymentAmount[i] - (-0);
          }
        }
        if (paymentFrequency === "Annual") {
          if (isLastDayOfMonthh(incomeDate)) {
            capitalRecovery = 0 - 0;
          } else {
            capitalRecovery = paymentAmount[i] - (-0);
          }
        }
        endBV = beginBV - capitalRecovery;
        incomeRecognized = income + sumIncomeRecognized;
      }
      schedule.push({
        term: i,
        paymentDate: DatePicker(paymentDate),
        paymentAmount: paymentrentamount,
        startDate: DatePicker(paymentDate),
        endDate: DatePicker(endDate),
        noOfDays,
        incomeDate: DatePicker(incomeDate),
        beginBV,
        income,
        capitalRecovery,
        endBV,
        incomeRecognized,
      });

      beginBV = endBV;

      // Second schedule
      const secondPaymentDate = new Date(endDate);
      secondPaymentDate.setDate(secondPaymentDate.getDate() + 1);

      const secondEndDate = new Date(paymentDate);
      secondEndDate.setMonth(secondEndDate.getMonth() + 1);
      secondEndDate.setDate(secondEndDate.getDate() - 1);

      const secondNoOfDays = 30 - noOfDays;
      const secondIncomeDate = new Date(secondEndDate);
      const secondIncome =
        (((beginBV - 0) * dailyYield) / 100) * secondNoOfDays;

      const secondCapitalRecovery = 0 - secondIncome;
      if (paymentFrequency === "Monthly") {
        if (isLastDayOfMonthh(secondIncomeDate)) {
          capitalRecovery = 0 - -0;
        } else {
          capitalRecovery =
            0 - secondIncome - schedule[schedule.length - 1].income;
        }
      }
      if (paymentFrequency === "Quarterly") {
        if (isLastDayOfMonthh(secondIncomeDate)) {
          capitalRecovery = 0 - -0;
        } else {
          capitalRecovery =
            0 - secondIncome - schedule[schedule.length - 1].income;
        }
      }
      if (paymentFrequency === "Semi-annual") {
        if (isLastDayOfMonthh(secondIncomeDate)) {
          capitalRecovery = 0 - -0;
        } else {
          capitalRecovery =
            0 - secondIncome - schedule[schedule.length - 1].income;
        }
      }
      if (paymentFrequency === "Annual") {
        if (isLastDayOfMonthh(secondIncomeDate)) {
          capitalRecovery = 0 - -0;
        } else {
          capitalRecovery =
            0 - secondIncome - schedule[schedule.length - 1].income;
        }
      }

      const secondEndBV = beginBV - capitalRecovery;
      const secondIncomeRecognized = secondIncome;
      paymentrentamount = 0;

      schedule.push({
        term: i,
        paymentDate: DatePicker(secondPaymentDate),
        paymentAmount: paymentrentamount,
        startDate: DatePicker(secondPaymentDate),
        endDate: DatePicker(secondEndDate),
        noOfDays: secondNoOfDays,
        incomeDate: DatePicker(secondIncomeDate),
        beginBV,
        income: secondIncome,
        capitalRecovery: capitalRecovery,
        endBV: secondEndBV,
        incomeRecognized: "",
      });

      beginBV = secondEndBV;
      sumIncomeRecognized = secondIncome;
    }
  }
  return schedule;
};

// const generateLeaseSchedule = (
//   startDate,
//   numberOfPayments,
//   financedAmount,
//   paymentAmount,
//   paymentFrequency,
//   contractiir,
//   residual
// ) => {
//   const schedule = [];
//   let beginBV = financedAmount;
//   let income = 0;
//   let capitalRecovery = 0;
//   let endBV = 0;
//   let incomeRecognized = 0;
//   let sumIncomeRecognized = 0;
//   startDate = new Date(startDate);
//   let monthlyYield = contractiir / 12;
//   let dailyYield = monthlyYield / 30;

//   for (let i = 0; i < numberOfPayments; i++) {
//     const paymentDate = new Date(startDate);

//     if (isFirstDayOfMonth(paymentDate)) {
//       const term = i + 1;
//       const paymentDate = new Date(startDate);
//       paymentDate.setMonth(startDate.getMonth() + i)
//       const endDate = new Date(paymentDate);
//       endDate.setMonth(paymentDate.getMonth() + 1);
//       endDate.setDate(endDate.getDate() - 1); // Subtract one day
//       const noOfDays = 30;
//       const incomeDate = new Date(endDate);

//       let paymentrentamount = paymentAmount[i]; // Default to payment amount

//       if (paymentFrequency === "Quarterly" && i % 3 === 0) {
//         income = ((beginBV - paymentAmount[i]) * monthlyYield) / 100;
//         capitalRecovery = paymentAmount[i] - income;
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income;
//         paymentrentamount = paymentAmount[i];

//       } else if (paymentFrequency === "Monthly") {
//         income = ((beginBV - paymentAmount[i]) * monthlyYield  )/ 100;
//         capitalRecovery = paymentAmount[i] - income;
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income;
//       } else if (paymentFrequency === "Semi-annual" && i % 6 === 0) {
//         income = ((beginBV - paymentAmount[i]) * monthlyYield) / 100;
//         capitalRecovery = paymentAmount[i] - income;
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income;
//       } else if (paymentFrequency === "Annual" && i % 12 === 0) {
//         income = ((beginBV - paymentAmount[i]) * monthlyYield) / 100;
//         capitalRecovery = paymentAmount[i] - income;
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income;
//       } else {
//         income = ((beginBV - 0) * monthlyYield) / 100;
//         capitalRecovery = 0 - income;
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income;
//         paymentrentamount = 0;
//       }

//       schedule.push({
//         [i]: paymentrentamount,
//         term,
//         paymentDate: DatePicker(paymentDate),
//         paymentAmount: paymentrentamount,
//         startDate: DatePicker(paymentDate),
//         endDate: DatePicker(endDate),
//         noOfDays,
//         incomeDate: DatePicker(incomeDate),
//         beginBV,
//         income,
//         capitalRecovery,
//         endBV,
//         incomeRecognized,
//       });

//       beginBV = endBV;
//     } else {
//       paymentDate.setMonth(startDate.getMonth() + i);

//       const endDate = new Date(paymentDate);
//       endDate.setMonth(paymentDate.getMonth() + 1);
//       endDate.setDate(0); // Set to the last day of the current month
//       const noOfDays = formulajs.DAYS360(paymentDate, endDate);
//       const incomeDate = new Date(endDate);

//       let paymentrentamount = paymentAmount[i]; // Default to payment amount

//       if (paymentFrequency === "Quarterly" && i % 3 === 0) {
//         income = ((beginBV - paymentAmount[i]) * dailyYield * noOfDays) / 100;
//         if (isLastDayOfMonthh(incomeDate)) {
//           capitalRecovery = paymentAmount[i] - (-0);
//         } else {
//           capitalRecovery = paymentAmount[i] - income;
//         }
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income + sumIncomeRecognized;
//         paymentrentamount = paymentAmount[i];
//       } else if (paymentFrequency === "Annual" && i % 12 === 0) {
//         income = ((beginBV - paymentAmount) * dailyYield * noOfDays) / 100;
//         if (isLastDayOfMonthh(incomeDate)) {
//           capitalRecovery = paymentAmount[i] - (-0);
//         } else {
//           capitalRecovery = paymentAmount[i] - income;
//         }
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income + sumIncomeRecognized;
//         paymentrentamount = paymentAmount[i];
//       } else if (paymentFrequency === "Semi-annual" && i % 6 === 0) {
//         income = ((beginBV - paymentAmount[i]) * dailyYield * noOfDays) / 100;
//         if (isLastDayOfMonthh(incomeDate)) {
//           capitalRecovery = paymentAmount[i] - (-0);
//         } else {
//           capitalRecovery = paymentAmount[i] - income;
//         }
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income + sumIncomeRecognized;
//         paymentrentamount = paymentAmount[i];
//       } else if (paymentFrequency === "Monthly") {
//         income = (((beginBV - paymentAmount[i]) * dailyYield) / 100) * noOfDays;
//         if (isLastDayOfMonthh(incomeDate)) {
//           capitalRecovery = paymentAmount[i] - (-0);
//         } else {
//           capitalRecovery = paymentAmount[i] - income;
//         }
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income + sumIncomeRecognized;
//         paymentrentamount = paymentAmount[i];
//       } else {
//         income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
//         if (paymentFrequency === "Monthly") {
//           if (isLastDayOfMonthh(incomeDate)) {
//             capitalRecovery = paymentAmount[i] - income;
//           } else {
//             capitalRecovery = paymentAmount[i] - (-0);
//           }
//         }
//         if (paymentFrequency === "Quarterly") {
//           if (isLastDayOfMonthh(incomeDate)) {
//             capitalRecovery = 0 - 0;
//           } else {
//             capitalRecovery = paymentAmount[i] - (-0);
//           }
//         }
//         if (paymentFrequency === "Semi-annual") {
//           if (isLastDayOfMonthh(incomeDate)) {
//             capitalRecovery = 0 - 0;
//           } else {
//             capitalRecovery = paymentAmount[i] - (-0);
//           }
//         }
//         if (paymentFrequency === "Annual") {
//           if (isLastDayOfMonthh(incomeDate)) {
//             capitalRecovery = 0 - 0;
//           } else {
//             capitalRecovery = paymentAmount[i] - (-0);
//           }
//         }
//         endBV = beginBV - capitalRecovery;
//         incomeRecognized = income + sumIncomeRecognized;
//       }

//       schedule.push({
//         [i]: paymentrentamount,
//         term: i,
//         paymentDate: DatePicker(paymentDate),
//         paymentAmount: paymentrentamount,
//         startDate: DatePicker(paymentDate),
//         endDate: DatePicker(endDate),
//         noOfDays,
//         incomeDate: DatePicker(incomeDate),
//         beginBV,
//         income,
//         capitalRecovery,
//         endBV,
//         incomeRecognized,
//       });

//       beginBV = endBV;

//       // Second schedule
//       const secondPaymentDate = new Date(endDate);
//       secondPaymentDate.setDate(secondPaymentDate.getDate() + 1);

//       const secondEndDate = new Date(paymentDate);
//       secondEndDate.setMonth(secondEndDate.getMonth() + 1);
//       secondEndDate.setDate(secondEndDate.getDate() - 1);

//       const secondNoOfDays = 30 - noOfDays;
//       const secondIncomeDate = new Date(secondEndDate);
//       const secondIncome =
//         (((beginBV - 0) * dailyYield) / 100) * secondNoOfDays;

//       const secondCapitalRecovery = 0 - secondIncome;
//       if (paymentFrequency === "Monthly") {
//         if (isLastDayOfMonthh(secondIncomeDate)) {
//           capitalRecovery = 0 - -0;
//         } else {
//           capitalRecovery =
//             0 - secondIncome - schedule[schedule.length - 1].income;
//         }
//       }
//       if (paymentFrequency === "Quarterly") {
//         if (isLastDayOfMonthh(secondIncomeDate)) {
//           capitalRecovery = 0 - -0;
//         } else {
//           capitalRecovery =
//             0 - secondIncome - schedule[schedule.length - 1].income;
//         }
//       }
//       if (paymentFrequency === "Semi-annual") {
//         if (isLastDayOfMonthh(secondIncomeDate)) {
//           capitalRecovery = 0 - -0;
//         } else {
//           capitalRecovery =
//             0 - secondIncome - schedule[schedule.length - 1].income;
//         }
//       }
//       if (paymentFrequency === "Annual") {
//         if (isLastDayOfMonthh(secondIncomeDate)) {
//           capitalRecovery = 0 - -0;
//         } else {
//           capitalRecovery =
//             0 - secondIncome - schedule[schedule.length - 1].income;
//         }
//       }

//       const secondEndBV = beginBV - capitalRecovery;
//       const secondIncomeRecognized = secondIncome;
//       paymentrentamount = 0;

//       schedule.push({
//         term: i,
//         paymentDate: DatePicker(secondPaymentDate),
//         paymentAmount: paymentrentamount,
//         startDate: DatePicker(secondPaymentDate),
//         endDate: DatePicker(secondEndDate),
//         noOfDays: secondNoOfDays,
//         incomeDate: DatePicker(secondIncomeDate),
//         beginBV,
//         income: secondIncome,
//         capitalRecovery: capitalRecovery,
//         endBV: secondEndBV,
//         incomeRecognized: "",
//       });

//       beginBV = secondEndBV;
//       sumIncomeRecognized = secondIncome;
//     }
//   }
//   return schedule;
// };

const generateRentalAdvanceAmortSchedule = (
  startDate,
  numberOfPayments,
  financedAmount,
  paymentAmount,
  paymentFrequency,
  contractiir,
  residual,
  rentalAmount
) => {


  const schedule = [];
  let beginBV = financedAmount;
  let income = 0;
  let capitalRecovery = 0;
  let endBV = 0;
  let incomeRecognized = 0;
  // let paymentrentamount = paymentAmount;
  let sumIncomeRecognized = 0;
  let total_depriciation = financedAmount - residual;
  let bookDepericiation = total_depriciation / numberOfPayments;
  startDate = new Date(startDate);
  let monthlyYield = contractiir / 12;
  let dailyYield = monthlyYield / 30;
  let rentalincome = 0;
  let firstbookDepericiation = 0;

  const roundToTwoDecimals = (num) => {
    const rounded = Math.round(num * 100) / 100;
    return Math.abs(rounded) < 0.01 ? 0 : rounded;
  };
  let depriciat = roundToTwoDecimals(total_depriciation / numberOfPayments)


  for (let i = 0; i < numberOfPayments; i++) {
    const paymentDate = new Date(startDate);
    if (isFirstDayOfMonth(paymentDate)) {
      const term = i + 1;
      const paymentDate = new Date(startDate);
      paymentDate.setMonth(startDate.getMonth() + i);
      const endDate = new Date(paymentDate);
      endDate.setMonth(paymentDate.getMonth() + 1);
      endDate.setDate(endDate.getDate() - 1); // Subtract one day
      const noOfDays = 30;
      const incomeDate = new Date(endDate);
      let paymentrentamount = paymentAmount[i];

      if (paymentFrequency === "Quarterly" && i % 3 === 0) {
        income = ((beginBV - paymentAmount[i]) * monthlyYield) / 100;
        capitalRecovery = paymentAmount[i] - income;
        // endBV = beginBV - capitalRecovery;
        endBV = beginBV - bookDepericiation;
        paymentrentamount = paymentAmount[i];
        rentalincome = rentalAmount[i] / 3;
        incomeRecognized = rentalincome;
      } else if (paymentFrequency === "Monthly") {
        income = ((beginBV - paymentAmount[i]) * monthlyYield) / 100;
        capitalRecovery = paymentAmount[i] - income;
        endBV = beginBV - bookDepericiation;
        paymentrentamount = paymentAmount[i];
        rentalincome = rentalAmount[i];
        incomeRecognized = rentalincome;
      } else if (paymentFrequency === "Semi-annual" && i % 6 === 0) {
        income = ((beginBV - paymentAmount[i]) * monthlyYield) / 100;
        capitalRecovery = paymentAmount[i] - income;
        // endBV = beginBV - capitalRecovery;
        endBV = beginBV - bookDepericiation;
        rentalincome = rentalAmount[i] / 6;
        incomeRecognized = rentalincome;
      } else if (paymentFrequency === "Annual" && i % 12 === 0) {
        income = ((beginBV - paymentAmount[i]) * monthlyYield) / 100;
        capitalRecovery = paymentAmount[i] - income;
        // endBV = beginBV - capitalRecovery;
        endBV = beginBV - bookDepericiation;
        rentalincome = rentalAmount[i] / 12;
        incomeRecognized = rentalincome;
      } else {
        income = ((beginBV - 0) * monthlyYield) / 100;
        capitalRecovery = 0 - income;
        // endBV = beginBV - capitalRecovery;
        endBV = beginBV - bookDepericiation;
        paymentrentamount = 0;
        incomeRecognized = paymentrentamount;

        if (paymentFrequency === "Quarterly" && (i + 1) % 3 === 0) {
          rentalincome = rentalAmount[i] / 3;
        } else if (paymentFrequency === "Monthly") {
          rentalincome = rentalAmount[i];
        } else if (paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0) {
          rentalincome = rentalAmount[i] / 6;
          //  paymentrentamount = paymentAmount[i]
        } else if (paymentFrequency === "Annual" && (i + 1) % 12 === 0) {
          rentalincome = rentalAmount[i] / 12;
        }
        // rentalincome = (paymentAmount[i]/noOfDays)*10
      }

      // schedule.push({
      //   term,
      //   paymentDate: DatePicker(paymentDate),
      //   periodicpaymentAmount: paymentrentamount,
      //   startDate: DatePicker(paymentDate),
      //   endDate: DatePicker(endDate),
      //   noOfDays,
      //   incomeDate: DatePicker(incomeDate),
      //   beginBV,
      //   rentalincome: rentalincome,
      //   income,
      //   bookDepericiation,
      //   capitalRecovery,
      //   endBV,
      //   incomeRecognized,
      // });
      schedule.push({
        term,
        paymentDate: DatePicker(paymentDate),
        periodicpaymentAmount: paymentrentamount,
        startDate: DatePicker(paymentDate),
        endDate: DatePicker(endDate),
        noOfDays,
        incomeDate: DatePicker(incomeDate),
        beginBV: roundToTwoDecimals(beginBV),
        // rentalincome: roundToTwoDecimals(rentalincome),
        rentalincome: (rentalincome),
        income: roundToTwoDecimals(income),
        bookDepericiation: roundToTwoDecimals(bookDepericiation),
        capitalRecovery: roundToTwoDecimals(capitalRecovery),
        endBV: roundToTwoDecimals(endBV),
        incomeRecognized: roundToTwoDecimals(incomeRecognized),
      });

      beginBV = endBV;
      if (i === numberOfPayments - 1) {

        const depreciationDifference = (total_depriciation) - (depriciat * numberOfPayments)
        let bookDepreciationCurrent = roundToTwoDecimals(bookDepericiation + depreciationDifference);
        schedule[schedule.length - 1].bookDepericiation = roundToTwoDecimals(
          bookDepreciationCurrent
        );
      }
    } else {
      let ter = i + 1;

      paymentDate.setMonth(startDate.getMonth() + i);
      const StartDate = new Date(startDate);
      StartDate.setMonth(StartDate.getMonth() + i);
      const endDate = new Date(paymentDate);
      endDate.setMonth(paymentDate.getMonth() + 1);
      endDate.setDate(0); // Set to the last day of the current month
      const noOfDays = formulajs.DAYS360(StartDate, endDate);
      const incomeDate = new Date(endDate);
      let paymentrentamount = paymentAmount[i];

      if (paymentFrequency === "Quarterly" && i % 3 === 0) {
        income = ((beginBV - paymentAmount[i]) * dailyYield * noOfDays) / 100;
        capitalRecovery = paymentAmount[i] - income;
        firstbookDepericiation =
          (((financedAmount - residual) / numberOfPayments) * noOfDays) / 30;
        // rentalincome      = (paymentAmount/30)*noOfDays
        rentalincome = (rentalAmount[i] / 90) * noOfDays;
        endBV = beginBV - firstbookDepericiation;
        incomeRecognized = rentalincome + sumIncomeRecognized;
        paymentrentamount = paymentAmount[i];
      } else if (paymentFrequency === "Annual" && i % 12 === 0) {
        income = ((beginBV - paymentAmount[i]) * dailyYield * noOfDays) / 100;
        capitalRecovery = paymentAmount[i] - income;
        firstbookDepericiation =
          (((financedAmount - residual) / numberOfPayments) * noOfDays) / 30;
        rentalincome = (rentalAmount[i] / 360) * noOfDays;
        endBV = beginBV - firstbookDepericiation;
        incomeRecognized = rentalincome + sumIncomeRecognized;
        paymentrentamount = paymentAmount[i];
      } else if (paymentFrequency === "Semi-annual" && i % 6 === 0) {
        income = ((beginBV - paymentAmount[i]) * dailyYield * noOfDays) / 100;
        capitalRecovery = paymentAmount[i] - income;
        firstbookDepericiation =
          (((financedAmount - residual) / numberOfPayments) * noOfDays) / 30;
        rentalincome = (rentalAmount[i] / 180) * noOfDays;
        endBV = beginBV - firstbookDepericiation;
        incomeRecognized = rentalincome + sumIncomeRecognized;
        paymentrentamount = paymentAmount[i];
      } else if (paymentFrequency === "Monthly") {
        income = (((beginBV - paymentAmount[i]) * dailyYield) / 100) * noOfDays;
        capitalRecovery = paymentAmount[i] - income;
        // endBV = beginBV - capitalRecovery;
        firstbookDepericiation =
          (((financedAmount - residual) / numberOfPayments) * noOfDays) / 30;
        rentalincome = (rentalAmount[i] / 30) * noOfDays;
        incomeRecognized = rentalincome + sumIncomeRecognized;
        endBV = beginBV - firstbookDepericiation;
        paymentrentamount = paymentAmount[i];
      } else {
        income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
        capitalRecovery = 0 - income;
        // endBV = beginBV - capitalRecovery;
        firstbookDepericiation =
          (((financedAmount - residual) / numberOfPayments) * noOfDays) / 30;
        // rentalincome      = (paymentAmount/30)*noOfDays
        endBV = beginBV - firstbookDepericiation;
        if (paymentFrequency === "Quarterly") {
          rentalincome = (rentalAmount[i] / 90) * noOfDays;
          incomeRecognized = rentalincome + sumIncomeRecognized;
        } else if (paymentFrequency === "Monthly") {
          rentalincome = (rentalAmount[i] / 30) * noOfDays;
          incomeRecognized = rentalincome + sumIncomeRecognized;
        } else if (paymentFrequency === "Semi-annual") {
          rentalincome = (rentalAmount[i] / 180) * noOfDays;
          incomeRecognized = rentalincome + sumIncomeRecognized;

          //  paymentrentamount = paymentAmount
        } else if (paymentFrequency === "Annual") {
          rentalincome = (rentalAmount[i] / 360) * noOfDays;
          incomeRecognized = rentalincome + sumIncomeRecognized;
        }
        // rentalincome      = (paymentAmount/30)*noOfDays
        // endBV = beginBV - rentalincome;
      }
      // const income =
      //   (((beginBV - paymentAmount) * dailyYield) / 100) * noOfDays;
      // const capitalRecovery = paymentAmount - income;
      // const endBV = beginBV - capitalRecovery;
      // const incomeRecognized = income;

      // schedule.push({
      //   term: i,
      //   paymentDate: DatePicker(paymentDate),
      //   periodicpaymentAmount: paymentrentamount,
      //   startDate: DatePicker(StartDate),
      //   endDate: DatePicker(endDate),
      //   noOfDays,
      //   incomeDate: DatePicker(incomeDate),
      //   beginBV,
      //   rentalincome: rentalincome,
      //   income,
      //   bookDepericiation: firstbookDepericiation,
      //   capitalRecovery,
      //   endBV,
      //   incomeRecognized,
      // });
      schedule.push({
        term: i,
        paymentDate: DatePicker(paymentDate),
        periodicpaymentAmount: paymentrentamount,
        startDate: DatePicker(StartDate),
        endDate: DatePicker(endDate),
        noOfDays,
        incomeDate: DatePicker(incomeDate),
        beginBV: roundToTwoDecimals(beginBV),
        // rentalincome: roundToTwoDecimals(rentalincome),
        rentalincome: (rentalincome),
        income: roundToTwoDecimals(income),
        bookDepericiation: roundToTwoDecimals(firstbookDepericiation),
        capitalRecovery: roundToTwoDecimals(capitalRecovery),
        endBV: roundToTwoDecimals(endBV),
        incomeRecognized: roundToTwoDecimals(incomeRecognized),
      });


      beginBV = endBV;

      // Second schedule
      const secondPaymentDate = new Date(endDate);
      secondPaymentDate.setMonth(secondPaymentDate.getMonth());
      secondPaymentDate.setDate(secondPaymentDate.getDate() + 1);
      let laststart = new Date(StartDate);
      laststart.setMonth(endDate.getMonth());
      laststart.setDate(endDate.getDate() + 1);
      const secondEndDate = new Date(secondPaymentDate);
      secondEndDate.setMonth(secondEndDate.getMonth());
      secondEndDate.setDate(startDate.getDate() - 1);

      const secondNoOfDays = 30 - noOfDays;
      // const secondNoOfDays = formulajs.DAYS360(laststart, secondEndDate);
      const secondIncomeDate = new Date(secondEndDate);
      const secondIncome =
        (((beginBV - 0) * dailyYield) / 100) * secondNoOfDays;
      const secondCapitalRecovery = 0 - secondIncome;
      // const secondEndBV = beginBV - secondCapitalRecovery;
      // const secondEndBV = beginBV - bookDepericiation;
      // endBV = beginBV - bookDepericiation;
      // rentalincome      = (paymentAmount/30)*secondNoOfDays
      const SecondbookDepericiation =
        (((financedAmount - residual) / numberOfPayments) * secondNoOfDays) /
        30;
      const secondEndBV = beginBV - SecondbookDepericiation;
      const secondIncomeRecognized = secondIncome;
      paymentrentamount = 0;
      if (paymentFrequency === "Quarterly") {
        rentalincome = (rentalAmount[i] / 90) * secondNoOfDays;
      } else if (paymentFrequency === "Monthly") {
        rentalincome = (rentalAmount[i] / 30) * secondNoOfDays;
      } else if (paymentFrequency === "Semi-annual") {
        rentalincome = (rentalAmount[i] / 180) * secondNoOfDays;
        //  paymentrentamount = rentalAmount[i]
      } else if (paymentFrequency === "Annual") {
        rentalincome = (rentalAmount[i] / 360) * secondNoOfDays;
      }

      schedule.push({
        term: i,
        paymentDate: DatePicker(secondPaymentDate),
        periodicpaymentAmount: paymentrentamount,
        startDate: DatePicker(laststart),
        endDate: DatePicker(secondEndDate),
        noOfDays: secondNoOfDays,
        incomeDate: DatePicker(secondIncomeDate),
        beginBV: roundToTwoDecimals(beginBV),
        // rentalincome: roundToTwoDecimals(rentalincome),
        rentalincome: (rentalincome),
        income: roundToTwoDecimals(income),
        bookDepericiation: roundToTwoDecimals(SecondbookDepericiation),
        capitalRecovery: roundToTwoDecimals(capitalRecovery),
        endBV: roundToTwoDecimals(secondEndBV),
        incomeRecognized: "",
      });

      beginBV = secondEndBV;
      sumIncomeRecognized = rentalincome;

      if (i === numberOfPayments - 1) {
        schedule[schedule.length - 1].incomeRecognized = roundToTwoDecimals(
          rentalincome
        );
        const depreciationDifference = total_depriciation - (depriciat * numberOfPayments)
        let bookDepreciationCurrent = roundToTwoDecimals(SecondbookDepericiation + depreciationDifference);
        schedule[schedule.length - 1].bookDepericiation = roundToTwoDecimals(
          bookDepreciationCurrent
        );
      }
    }
  }
  // if (residual > 0) {
  //   const ResidualPaymentDate = new Date(schedule[schedule.length - 1].endDate);
  //   ResidualPaymentDate.setDate(ResidualPaymentDate.getDate() + 1);

  //   const ResidualEndDate = new Date(ResidualPaymentDate);
  //   ResidualEndDate.setMonth(ResidualEndDate.getMonth() + 1);
  //   ResidualEndDate.setDate(ResidualEndDate.getDate() - 1);

  //   const ResidualNoOfDays = formulajs.DAYS360(
  //     ResidualPaymentDate,
  //     ResidualEndDate
  //   );
  //   const ResidualIncomeDate = new Date(ResidualEndDate);
  //   const ResidualIncome =
  //     (((beginBV - 0) * dailyYield) / 100) * ResidualNoOfDays;
  //   const ResidualCapitalRecovery = 0 - ResidualIncome;
  //   const ResidualEndBV = beginBV - ResidualCapitalRecovery;
  //   const ResidualIncomeRecognized = ResidualIncome;
  //   const ResidualbeginBV = schedule[schedule.length - 1].endBV;
  //   schedule.push({
  //     term: [1],
  //     paymentDate: DatePicker(ResidualPaymentDate),
  //     paymentAmount: 0,
  //     startDate: DatePicker(ResidualPaymentDate),
  //     endDate: DatePicker(ResidualEndDate),
  //     noOfDays: ResidualNoOfDays,
  //     incomeDate: DatePicker(ResidualIncomeDate),
  //     beginBV: ResidualbeginBV,
  //     income: ResidualIncome,
  //     capitalRecovery: ResidualCapitalRecovery,
  //     endBV: ResidualEndBV,
  //     incomeRecognized: ResidualIncomeRecognized,
  //   });
  // }
  return schedule;
};

const generateRentalArrearsSchedule = (
  startDate,
  numberOfPayments,
  financedAmount,
  paymentAmount,
  paymentFrequency,
  contractiir,
  residual,
  rentalAmount
) => {
  const schedule = [];
  let beginBV = financedAmount;
  let income = 0;
  let capitalRecovery = 0;
  let endBV = 0;
  let incomeRecognized = 0;
  // let paymentrentamount = paymentAmount;
  let sumIncomeRecognized = 0;
  startDate = new Date(startDate);
  let total_depriciation = financedAmount - residual;
  let bookDepericiation = total_depriciation / numberOfPayments;
  let monthlyYield = contractiir / 12;
  let dailyYield = monthlyYield / 30;
  let rentalincome = 0;
  let firstbookDepericiation = 0;
  const roundToTwoDecimals = (num) => {
    const rounded = Math.round(num * 100) / 100;
    return Math.abs(rounded) < 0.01 ? 0 : rounded;
  };

  let depriciat = roundToTwoDecimals(total_depriciation / numberOfPayments)


  for (let i = 0; i < numberOfPayments; i++) {
    const paymentDate = new Date(startDate);
    if (isFirstDayOfMonth(paymentDate)) {
      const term = i + 1;
      const paymentDate = new Date(startDate);
      paymentDate.setMonth(startDate.getMonth() + term);
      const startdate = new Date(startDate);
      startdate.setMonth(startdate.getMonth() + i);
      const endDate = new Date(startdate);
      endDate.setMonth(startdate.getMonth() + 1);
      endDate.setDate(endDate.getDate() - 1);
      const noOfDays = 30;
      const incomeDate = new Date(endDate);
      let paymentrentamount = paymentAmount[i];

      if (paymentFrequency === "Quarterly" && (i + 1) % 3 === 0) {
        income = ((beginBV - 0) * monthlyYield) / 100;
        capitalRecovery = paymentAmount[i] - income;
        endBV = beginBV - bookDepericiation;
        paymentrentamount = paymentAmount[i];
        rentalincome = rentalAmount[i] / 3;
        incomeRecognized = rentalincome;
      } else if (paymentFrequency === "Monthly") {
        income = ((beginBV - 0) * monthlyYield) / 100;
        capitalRecovery = paymentAmount[i] - income;
        endBV = beginBV - bookDepericiation;
        rentalincome = rentalAmount[i];
        incomeRecognized = paymentAmount[i];
      } else if (paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0) {
        income = ((beginBV - 0) * monthlyYield) / 100;
        capitalRecovery = paymentAmount[i] - income;
        endBV = beginBV - bookDepericiation;
        paymentrentamount = paymentAmount[i];
        rentalincome = rentalAmount[i] / 6;
        incomeRecognized = rentalincome;
      } else if (paymentFrequency === "Annual" && (i + 1) % 12 === 0) {
        income = ((beginBV - 0) * monthlyYield) / 100;
        capitalRecovery = paymentAmount[i] - income;
        endBV = beginBV - bookDepericiation;
        paymentrentamount = paymentAmount[i];
        rentalincome = rentalAmount[i] / 12;
        incomeRecognized = rentalincome;
      } else {
        income = ((beginBV - 0) * monthlyYield) / 100;
        capitalRecovery = 0 - income;
        endBV = beginBV - bookDepericiation;
        paymentrentamount = 0;
        if (paymentFrequency === "Quarterly" && i % 3 === 0) {
          rentalincome = rentalAmount[i] / 3;
        } else if (paymentFrequency === "Monthly") {
          rentalincome = rentalAmount[i];
        } else if (paymentFrequency === "Semi-annual" && i % 6 === 0) {
          rentalincome = rentalAmount[i] / 6;
        } else if (paymentFrequency === "Annual" && i % 12 === 0) {
          rentalincome = rentalAmount[i] / 12;
        }
        incomeRecognized = rentalincome;
      }
      schedule.push({
        term,
        paymentDate: DatePicker(endDate),
        periodicpaymentAmount: paymentrentamount,
        startDate: DatePicker(startdate),
        endDate: DatePicker(endDate),
        noOfDays,
        incomeDate: DatePicker(incomeDate),
        beginBV: roundToTwoDecimals(beginBV),
        // rentalincome: roundToTwoDecimals(rentalincome),
        rentalincome: (rentalincome),
        income: roundToTwoDecimals(income),
        bookDepericiation: roundToTwoDecimals(bookDepericiation),
        capitalRecovery: roundToTwoDecimals(capitalRecovery),
        endBV: roundToTwoDecimals(endBV),
        incomeRecognized: roundToTwoDecimals(incomeRecognized),
      });

      beginBV = endBV;
      if (i === numberOfPayments - 1) {

        const depreciationDifference = (total_depriciation) - (depriciat * numberOfPayments)
        let bookDepreciationCurrent = roundToTwoDecimals(bookDepericiation + depreciationDifference);
        schedule[schedule.length - 1].bookDepericiation = roundToTwoDecimals(
          bookDepreciationCurrent
        );
      }
    } else {
      let ter = i + 1;
      paymentDate.setMonth(startDate.getMonth() + ter);
      paymentDate.setDate(0);
      const StartDate = new Date(startDate);
      StartDate.setMonth(StartDate.getMonth() + i);

      const endDate = new Date(paymentDate);
      const noOfDays = formulajs.DAYS360(StartDate, endDate);
      const incomeDate = new Date(endDate);
      let paymentrentamount = paymentAmount[i];

      if (paymentFrequency === "Quarterly" && (i + 1) % 3 === 0) {
        income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
        capitalRecovery = 0 - income;
        firstbookDepericiation =
          (((financedAmount - residual) / numberOfPayments) * noOfDays) / 30;
        rentalincome = (rentalAmount[i] / 90) * noOfDays;
        endBV = beginBV - firstbookDepericiation;
        incomeRecognized = rentalincome + sumIncomeRecognized;
        paymentrentamount = 0;
      } else if (paymentFrequency === "Annual" && (i + 1) % 12 === 0) {
        income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
        capitalRecovery = paymentAmount[i] - income;
        firstbookDepericiation =
          (((financedAmount - residual) / numberOfPayments) * noOfDays) / 30;
        rentalincome = (rentalAmount[i] / 360) * noOfDays;
        endBV = beginBV - firstbookDepericiation;
        incomeRecognized = rentalincome + sumIncomeRecognized;
        paymentrentamount = 0;
      } else if (paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0) {
        income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
        capitalRecovery = paymentAmount[i] - income;
        firstbookDepericiation =
          (((financedAmount - residual) / numberOfPayments) * noOfDays) / 30;
        rentalincome = (rentalAmount[i] / 180) * noOfDays;
        endBV = beginBV - firstbookDepericiation;
        incomeRecognized = rentalincome + sumIncomeRecognized;
        paymentrentamount = 0;
      } else if (paymentFrequency === "Monthly") {
        income = (((beginBV - 0) * dailyYield) / 100) * noOfDays;
        capitalRecovery = 0 - income;
        firstbookDepericiation =
          (((financedAmount - residual) / numberOfPayments) * noOfDays) / 30;
        rentalincome = (rentalAmount[i] / 30) * noOfDays;
        endBV = beginBV - firstbookDepericiation;
        incomeRecognized = rentalincome + sumIncomeRecognized;
        paymentrentamount = 0;
      } else {
        income = ((beginBV - 0) * dailyYield * noOfDays) / 100;
        capitalRecovery = 0 - income;
        paymentrentamount = 0;
        firstbookDepericiation =
          (((financedAmount - residual) / numberOfPayments) * noOfDays) / 30;
        endBV = beginBV - firstbookDepericiation;
        if (paymentFrequency === "Quarterly") {
          rentalincome = (rentalAmount[i] / 90) * noOfDays;
        } else if (paymentFrequency === "Monthly") {
          rentalincome = (rentalAmount[i] / 30) * noOfDays;
        } else if (paymentFrequency === "Semi-annual") {
          rentalincome = (rentalAmount[i] / 180) * noOfDays;
        } else if (paymentFrequency === "Annual") {
          rentalincome = (rentalAmount[i] / 360) * noOfDays;
        }
        incomeRecognized = rentalincome + sumIncomeRecognized;
      }
      schedule.push({
        term: i,
        paymentDate: DatePicker(endDate),
        periodicpaymentAmount: paymentrentamount,
        startDate: DatePicker(StartDate),
        endDate: DatePicker(endDate),
        noOfDays,
        incomeDate: DatePicker(incomeDate),
        beginBV: roundToTwoDecimals(beginBV),
        // rentalincome: roundToTwoDecimals(rentalincome),
        rentalincome: (rentalincome),
        income: roundToTwoDecimals(income),
        bookDepericiation: roundToTwoDecimals(firstbookDepericiation),
        capitalRecovery: roundToTwoDecimals(capitalRecovery),
        endBV: roundToTwoDecimals(endBV),
        incomeRecognized: roundToTwoDecimals(incomeRecognized),
      });

      beginBV = endBV;

      // Second schedule
      const secondPaymentDate = new Date(startDate);
      secondPaymentDate.setMonth(startDate.getMonth() + ter);
      secondPaymentDate.setDate(secondPaymentDate.getDate());

      let laststart = new Date(StartDate);
      laststart.setMonth(endDate.getMonth());
      laststart.setDate(endDate.getDate() + 1);
      const secondEndDate = new Date(secondPaymentDate);
      secondEndDate.setMonth(secondEndDate.getMonth());
      secondEndDate.setDate(secondEndDate.getDate() - 1);

      const secondNoOfDays = 30 - noOfDays;
      const secondIncomeDate = new Date(secondEndDate);
      if (paymentFrequency === "Quarterly") {
        rentalincome = (rentalAmount[i] / 90) * secondNoOfDays;
      } else if (paymentFrequency === "Monthly") {
        rentalincome = (rentalAmount[i] / 30) * secondNoOfDays;
      } else if (paymentFrequency === "Semi-annual") {
        rentalincome = (rentalAmount[i] / 180) * secondNoOfDays;
      } else if (paymentFrequency === "Annual") {
        rentalincome = (rentalAmount[i] / 360) * secondNoOfDays;
      }
      const secondIncome =
        paymentFrequency === "Quarterly" && (i + 1) % 3 === 0
          ? ((beginBV * dailyYield) / 100) * secondNoOfDays
          : ((beginBV * dailyYield) / 100) * secondNoOfDays;
      const secondCapitalRecovery =
        paymentFrequency === "Quarterly" && (i + 1) % 3 === 0
          ? paymentAmount[i] - secondIncome
          : paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0
            ? paymentAmount[i] - secondIncome
            : paymentFrequency === "Annual" && (i + 1) % 12 === 0
              ? paymentAmount[i] - secondIncome
              : paymentFrequency === "Monthly"
                ? paymentAmount[i] - secondIncome
                : 0 - secondIncome;
      const SecondbookDepericiation =
        (((financedAmount - residual) / numberOfPayments) * secondNoOfDays) /
        30;
      const secondEndBV = beginBV - SecondbookDepericiation;
      const secondIncomeRecognized = rentalincome;
      if (paymentFrequency === "Quarterly" && (i + 1) % 3 === 0) {
        paymentrentamount = paymentAmount[i];
      } else if (paymentFrequency === "Monthly") {
        paymentrentamount = paymentAmount[i];
      } else if (paymentFrequency === "Semi-annual" && (i + 1) % 6 === 0) {
        paymentrentamount = paymentAmount[i];
      } else if (paymentFrequency === "Annual" && (i + 1) % 12 === 0) {
        paymentrentamount = paymentAmount[i];
      }

      schedule.push({
        term: i,
        // paymentDate: DatePicker(secondEndDate),
        paymentDate: DatePicker(secondPaymentDate),
        periodicpaymentAmount: paymentrentamount,
        startDate: DatePicker(laststart),
        endDate: DatePicker(secondEndDate),
        noOfDays: secondNoOfDays,
        incomeDate: DatePicker(secondIncomeDate),
        beginBV: roundToTwoDecimals(beginBV),
        // rentalincome: roundToTwoDecimals(rentalincome),
        rentalincome: (rentalincome),
        income: roundToTwoDecimals(income),
        bookDepericiation: roundToTwoDecimals(SecondbookDepericiation),
        capitalRecovery: roundToTwoDecimals(capitalRecovery),
        endBV: roundToTwoDecimals(secondEndBV),
        incomeRecognized: "",
      });

      beginBV = secondEndBV;
      sumIncomeRecognized = rentalincome;

      if (i === numberOfPayments - 1) {
        schedule[schedule.length - 1].incomeRecognized = roundToTwoDecimals(
          rentalincome
        );
        const depreciationDifference = total_depriciation - (depriciat * numberOfPayments)
        let bookDepreciationCurrent = roundToTwoDecimals(SecondbookDepericiation + depreciationDifference);
        schedule[schedule.length - 1].bookDepericiation = roundToTwoDecimals(
          bookDepreciationCurrent
        );
      }
    }
  }
  return schedule;
};

const visibleColumn = (columns) => {
  const visible = columns.filter(column => !column.hidden)
  return visible
}

const handleSearch = (tableRef) => {
  tableRef.current.onQueryChange();
};

const fetchAllDataForExport = async (selectedValue, selectedValue2, contractNumber) => {
  let allData = [];
  let currentPage = 0;
  const pageSize = 10; // Your page size

  while (true) {
    const query = {
      pageSize,
      page: currentPage,
      search: '',
    };

    let customerName = "";

    if (selectedValue) {
      customerName = selectedValue.id;
    }

    if (selectedValue2) {
      contractNumber = selectedValue2.contract_number
    }

    const url = API + "contracts/contracts/0/?" + "status=Active" + "&per_page=" + query.pageSize + "&page=" + (query.page + 1) + "&search=" + query.search + "&contractNumber=" + contractNumber + "&customerName=" + customerName;

    try {
      const response = await fetch(url, { headers: authHeader() });
      const result = await response.json();

      if (result.data.length === 0) {
        break;
      }

      allData = allData.concat(result.data);
      currentPage++;
    } catch (error) {
      console.error("Error fetching data:", error);
      break;
    }
  }

  return allData;
};
const fetchActicecontractsDataForExport = async (selectedValue, selectedValue2, contractNumber) => {
  let allData = [];
  let currentPage = 0;
  const pageSize = 10; // Your page size

  while (true) {
    const query = {
      pageSize,
      page: currentPage,
      search: '',
    };

    let customerName = "";

    if (selectedValue) {
      customerName = selectedValue.id;
    }

    if (selectedValue2) {
      contractNumber = selectedValue2.contract_number
    }

    const url = API + "helper/active-contracts/?" + "status=Active" + "&per_page=" + query.pageSize + "&page=" + (query.page + 1) + "&search=" + query.search + "&contractNumber=" + contractNumber + "&customerName=" + customerName;

    try {
      const response = await fetch(url, { headers: authHeader() });
      const result = await response.json();

      if (result.data.length === 0) {
        break;
      }

      allData = allData.concat(result.data);
      currentPage++;
    } catch (error) {
      console.error("Error fetching data:", error);
      break;
    }
  }

  return allData;
};

const AverageOriginalTermDataForExport = async (selectedValue, selectedValue2, contractNumber) => {
  let allData = [];
  let currentPage = 0;
  const pageSize = 10; // Your page size

  while (true) {
    const query = {
      pageSize,
      page: currentPage,
      search: '',
    };

    let customerName = "";

    if (selectedValue) {
      customerName = selectedValue.id;
    }

    if (selectedValue2) {
      contractNumber = selectedValue2.contract_number
    }

    const url = API + "helper/original-term-report/?" + "status=Active" + "&per_page=" + query.pageSize + "&page=" + (query.page + 1) + "&search=" + query.search + "&contractNumber=" + contractNumber + "&customerName=" + customerName;

    try {
      const response = await fetch(url, { headers: authHeader() });
      const result = await response.json();

      if (result.data.length === 0) {
        break;
      }

      allData = allData.concat(result.data);
      currentPage++;
    } catch (error) {
      console.error("Error fetching data:", error);
      break;
    }
  }

  return allData;
};
const AverageReaminingTermDataForExport = async (selectedValue, selectedValue2, contractNumber) => {
  let allData = [];
  let currentPage = 0;
  const pageSize = 10; // Your page size

  while (true) {
    const query = {
      pageSize,
      page: currentPage,
      search: '',
    };

    let customerName = "";

    if (selectedValue) {
      customerName = selectedValue.id;
    }

    if (selectedValue2) {
      contractNumber = selectedValue2.contract_number
    }

    const url = API + "helper/remaining-term-report/?" + "status=Active" + "&per_page=" + query.pageSize + "&page=" + (query.page + 1) + "&search=" + query.search + "&contractNumber=" + contractNumber + "&customerName=" + customerName;

    try {
      const response = await fetch(url, { headers: authHeader() });
      const result = await response.json();

      if (result.data.length === 0) {
        break;
      }

      allData = allData.concat(result.data);
      currentPage++;
    } catch (error) {
      console.error("Error fetching data:", error);
      break;
    }
  }

  return allData;
};

const fetchAllPendingDataForExport = async (selectedValue, status, selectedValue2, contractNumber) => {
  let allData = [];
  let currentPage = 0;
  const pageSize = 10; // Your page size

  while (true) {
    const query = {
      pageSize,
      page: currentPage,
      search: '',
    };

    let customerName = "";

    if (selectedValue) {
      customerName = selectedValue.id;
    }

    if (selectedValue2) {
      contractNumber = selectedValue2.contract_number
    }

    const url = API + "contracts/by-status/0/?" + `status=${status}` + "&per_page=" + query.pageSize + "&page=" + (query.page + 1) + "&search=" + query.search + "&contractNumber=" + contractNumber + "&customerName=" + customerName;

    try {
      const response = await fetch(url, { headers: authHeader() });
      const result = await response.json();

      if (result.data.length === 0) {
        break;
      }

      allData = allData.concat(result.data);
      currentPage++;
    } catch (error) {
      console.error("Error fetching data:", error);
      break;
    }
  }

  return allData;
};

const Helper = {
  DatePicker,
  DateNormal,
  Dateview,
  DueDays,
  Amount,
  MonthDifference,
  calculatePaymentDates,
  generateSchedule,
  generateArrearsSchedule,
  calculatedLoanPaymentDates,
  generateRentalAdvanceAmortSchedule,
  generateRentalArrearsSchedule,
  generateLeaseSchedule,
  generateLeaseArrearsSchedule,
  visibleColumn,
  handleSearch,
  fetchAllDataForExport,
  fetchAllPendingDataForExport,
  TaxRateAmount,
  fetchActicecontractsDataForExport,
  AverageReaminingTermDataForExport,
  AverageOriginalTermDataForExport,
  DateTimeNormal,
};
export default Helper;
